<div style="overflow: hidden; height: 100%;">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">{{pageTitle}}</h3>
    <p-select *ngIf="itProfile && itProfiles" [options]="itProfiles" optionLabel="name"
      optionValue="clientITProfileId" [(ngModel)]="itProfile.clientITProfileId" (onChange)="onItProfileChanged($event)">
    </p-select>
    <div class="flex align-items-center">
      <p-button [text]="true" pTooltip="Create New" icon="pi pi-plus" (click)="createItProfile()"></p-button>
      <p-button *ngIf="itProfile" pTooltip="Clone" [text]="true" icon="pi pi-copy"
        (click)="copyItProfile(itProfile)"></p-button>
      <p-button *ngIf="itProfile" [text]="true" pTooltip="Edit Structure" icon="pi pi-pencil"
        [routerLink]="['/profiles', 'itProfile', itProfile.clientITProfileId, 'edit']"></p-button>
      <p-button *ngIf="itProfile" [text]="true" icon="pi pi-trash" severity="danger" mwlConfirmationPopover
        [title]="'Delete Selected IT Profile'" [popoverMessage]="
              'You are going to delete selected IT Profile. Are you sure?'
            " [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="bottom"
        (confirm)="removeItProfile()"></p-button>
      <p-button *ngIf="itProfile && returnToProjectId" [text]="true" icon="pi pi-briefcase"
        [routerLink]="['/projects/project', returnToProjectId]"></p-button>
    </div>
  </div>
  <form [formGroup]="formGroup" *ngIf="itProfile">
    <div style="display: flex; flex-direction: column;">
      <div>
        <mat-tab-group [linear]="false" class="matHeader" formArrayName="formArray">
          <mat-tab label="Settings">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Settings </mat-panel-title>
                    <mat-panel-description>
                      Manage SSP settings
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- SSP settings -->

                  <div class="section" formGroupName="11">
                    <ng-template matStepLabel>
                      <div>SSP Settings</div>
                    </ng-template>

                    <div class="input-div">
                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 120px;">Primary Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="primaryColor" class="color-picker"
                          (ngModelChange)="onPrimaryColorChange($event)"></ngx-colors>

                      </div>

                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 150px;">Primary Text Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="primaryTextColor" class="color-picker"
                          (ngModelChange)="onPrimaryTextColorChange($event)"></ngx-colors>
                      </div>
                    </div>

                    <div class="input-div">
                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 120px;">Secondary Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="secondaryColor" class="color-picker"
                          (ngModelChange)="onSecondaryColorChange($event)"></ngx-colors>
                      </div>


                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 150px;">Secondary Text Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="secondaryTextColor" class="color-picker"
                          (ngModelChange)="onSecondaryTextColorChange($event)"></ngx-colors>
                      </div>
                    </div>
                    <div class="input-div">
                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 120px;">Tertiary Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="tertiaryColor" class="color-picker"
                          (ngModelChange)="onTertiaryColorChange($event)"></ngx-colors>
                      </div>
                      <div class="input-field">
                        <label class="block font-bold mb-2" style="width: 150px;">Tertiary Text Color</label>
                        <ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;"
                          formControlName="tertiaryTextColor" class="color-picker"
                          (ngModelChange)="onTertiaryTextColorChange($event)"></ngx-colors>
                      </div>
                    </div>
                    <div class="input-con">
                      <div>
                        <label class="block font-bold mb-2" for="versionOfSsp">Version of SSP</label>
                        <input inputId="versionOfSsp" type="text" pInputText formControlName="versionOfSsp"
                          class="w-full p-inputtext" />
                      </div>
                      <div>
                        <label class="block font-bold mb-2" for="picker1">Date</label>
                        <input pInputText name="date" class="w-full p-inputtext" formControlName="date"
                          [matDatepicker]="picker1" required>
                        <mat-datepicker-toggle class="date-picker" matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </div>

                    </div>
                    <div style="display: flex; gap: 20px;">
                      <div class="example-full-width" style="width: 295px;">
                        <mat-checkbox type="text" formControlName="isFedRamp">
                          Display FedRAMP SSP Profile Elements
                        </mat-checkbox>
                      </div>
                      <div class="example-full-width" style="width: 295px;">
                        <mat-checkbox type="text" formControlName="includePolicies">
                          Include Policies
                        </mat-checkbox>
                      </div>
                    </div>
                    <div style="display: flex; gap: 20px;">
                      <div class="example-full-width" style="width: 295px;">
                        <mat-checkbox type="text" formControlName="includeOwnerNames">
                          Include company process owners
                        </mat-checkbox>
                      </div>
                      <div class="example-full-width" style="width: 295px;">
                        <mat-checkbox type="text" formControlName="includeResponsibility">
                          Include shared responsibility data
                        </mat-checkbox>
                      </div>
                    </div>
                    <div style="display: flex; gap: 20px;">
                      <div class="example-full-width" style="width: 295px;">
                        <mat-checkbox type="text" formControlName="includeSubitems">
                          Include Sub-items
                        </mat-checkbox>
                      </div>
                    </div>
                    <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">

                    </ng-container>

                    <div class="save-button">
                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title> Mapped Projects </mat-panel-title>
                    <mat-panel-description>
                      Projects mapped to this IT Profile
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                    <div *ngFor="let project of mappedProjects">
                      <a [routerLink]="['/projects/project', project.projectId]">{{project.name}}</a>
                    </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="Company">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> General </mat-panel-title>
                    <mat-panel-description>
                      Display and manage company details
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- General -->
                  <div formGroupName="11">
                    <div style="display:flex; gap:30px; width:70%">
                      <mat-form-field class="input-section">
                        <mat-label>Display Name for Company</mat-label>
                        <input matInput type="text" formControlName="sspCompanyName" />
                      </mat-form-field>
                      <mat-form-field class="input-section">
                        <mat-label>Author</mat-label>
                        <input matInput type="text" formControlName="author" />
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>
                    </div>

                    <mat-form-field class="textarea-section" style="width:70%">
                      <mat-label>Description</mat-label>
                      <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10" formControlName="description">
                                </textarea>
                    </mat-form-field>


                    <div class="save-button">
                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>

                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Owners & Contacts</mat-panel-title>
                    <mat-panel-description>
                      Manage environment owners and designated contacts
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Owners & Contacts -->
                  <div>
                    <div formGroupName="0" style="margin-bottom: 10px">
                      <ng-template matStepLabel>
                        Owners
                      </ng-template>
                      <p style="font-size:14px;"><strong>Owners of your IT environment:</strong></p>

                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 auto">
                          <div class="example-full-width" style="margin-top: 8px;">
                            <mat-checkbox type="text" formControlName="ownersSectionVisible">
                              Visible in SSP
                            </mat-checkbox>
                          </div>
                        </div>
                        <div style="flex:0 0 2%"></div>
                        <div style="flex:1 1 auto">
                          <mat-form-field class="input-section" style="margin-left: 20px;">
                            <mat-label>SSP Section Name</mat-label>
                            <input matInput required formControlName="ownersSectionTitle">
                          </mat-form-field>
                        </div>
                      </div>

                      <div style="display: flex; flex-direction: row;">
                        <div style="display: flex; flex-direction: column; flex:30%;">
                          <p style="font-size: 12px; font-weight: 600;">System Owner</p>
                          <mat-form-field class="input-section">
                            <mat-label>Full Name</mat-label>
                            <input matInput name="systemOwnerFullName" required
                              formControlName="systemOwnerFullNameFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="input-section">
                            <mat-label>Title</mat-label>
                            <input matInput name="systemOwnerTitle" required formControlName="systemOwnerTitleFormCtrl">

                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Company / Organization</mat-label>
                            <input matInput name="systemOwnerCompany" required
                              formControlName="systemOwnerCompanyFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Address</mat-label>
                            <input matInput name="systemOwnerAddress" required
                              formControlName="systemOwnerAddressFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Phone Number</mat-label>
                            <input matInput name="systemOwnerPhone" required formControlName="systemOwnerPhoneFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Email Address</mat-label>
                            <input matInput name="systemOwnerEmail" required formControlName="systemOwnerEmailFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                        </div>

                        <div style="flex:2%; display: flex; flex-direction: column;"></div>

                        <div style="display: flex; flex-direction: column; flex:30%;">
                          <p style="font-size: 12px; font-weight: 600; white-space: nowrap;">System Security Point of
                            Contact/Internal ISSO
                          </p>
                          <mat-form-field class="input-section">
                            <mat-label>Full Name</mat-label>
                            <input matInput name="securityPointFullName" required
                              formControlName="securityPointFullNameFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="input-section">
                            <mat-label>Title</mat-label>
                            <input matInput name="securityPointTitle" required
                              formControlName="securityPointTitleFormCtrl">

                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Company / Organization</mat-label>
                            <input matInput name="securityPointCompany" required
                              formControlName="securityPointCompanyFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Address</mat-label>
                            <input matInput name="securityPointAddress" required
                              formControlName="securityPointAddressFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Phone Number</mat-label>
                            <input matInput name="securityPointPhone" required
                              formControlName="securityPointPhoneFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Email Address</mat-label>
                            <input matInput name="securityPointEmail" required
                              formControlName="securityPointEmailFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                        </div>

                        <div style="flex:2%; display: flex; flex-direction: column;"></div>

                        <div style="display: flex; flex-direction: column; flex:30%;">
                          <p style="font-size: 12px; font-weight: 600;">System Security Officer/AO</p>
                          <mat-form-field class="input-section">
                            <mat-label>Full Name</mat-label>
                            <input matInput name="securityOfficerrFullName" required
                              formControlName="securityOfficerFullNameFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Title</mat-label>
                            <input matInput name="securityOfficerTitle" required
                              formControlName="securityOfficerTitleFormCtrl">

                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Company / Organization</mat-label>
                            <input matInput name="securityOfficerCompany" required
                              formControlName="securityOfficerCompanyFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Address</mat-label>
                            <input matInput name="securityOfficerAddress" required
                              formControlName="securityOfficerAddressFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Phone Number</mat-label>
                            <input matInput name="securityOfficerPhone" required
                              formControlName="securityOfficerPhoneFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>Email Address</mat-label>
                            <input matInput name="securityOfficerEmail" required
                              formControlName="securityOfficerEmailFormCtrl">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="save-button">
                        <button mat-raised-button (click)="onDone()">
                          Save
                        </button>
                      </div>
                    </div>

                    <!-- Designated Contacts -->

                    <div [stepControl]="{invalid: false}">
                      <ng-template matStepLabel>
                        Other Designated Contacts
                      </ng-template>
                      <p style="font-size:14px;margin: 0px 0 5px 0;">
                        <strong>Designated Contacts</strong>
                        <span class="tooltip-trigger"
                          style="display: inline-block;margin-left: 10px; width: 20px; height: 20px;"
                          pTooltip='This section is only displayed in the Standard w/ Recs template'>

                        </span>
                      </p>
                      <div formGroupName="16">
                        <div style="display: flex; flex-direction: row;">
                          <div style="flex:0 0 auto">
                            <div class="example-full-width" style="margin-top: 8px;">
                              <mat-checkbox type="text" formControlName="contactsSectionVisible">
                                Visible in SSP
                              </mat-checkbox>
                            </div>
                          </div>
                          <div style="flex:0 0 2%"></div>
                          <div style="flex:1 1 auto">
                            <mat-form-field class="input-section" style="margin-left: 20px;">
                              <mat-label>SSP Section Name</mat-label>
                              <input matInput required formControlName="contactsSectionTitle">
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <p-table [value]="otherDesignatedContacts" [rows]="10" selectionMode="single"
                        [(selection)]="selectedOtherDesignatedContact" [paginator]="true"
                        [style]="{'margin-top':'10px'}" sortField="otherDesignatedContactId"
                        #otherDesignatedContactsTable>

                        <ng-template pTemplate="caption">
                          <div class="ui-helper-clearfix">
                            <button type="button" pButton icon="pi pi-plus"
                              (click)="showDialogToAddOtherDesignatedContact()" class="risksponge-button"
                              style="float:right">
                            </button>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                          <tr>
                            <th *ngFor="let col of otherDesignatedContactsCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                              {{ col.header }}
                              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <th [ngStyle]="{width:'7em'}"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                          <tr>
                            <td>{{ item.role }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ item.company }}</td>
                            <td>{{ item.address }}<br />{{ item.phone }}<br />{{ item.email }}</td>
                            <td>
                              <button type="button" pButton class="risksponge-button"
                                (click)="onOtherDesignatedContactEdit(item)" icon="pi pi-pencil">
                              </button>

                              <button type="button" pButton class="risksponge-button"
                                (click)="onOtherDesignatedContactDelete(item)" icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>


                      <p-dialog header="Other Designated Contact" [(visible)]="displayOtherDesignatedContactDialog"
                         showEffect="fade" [width]="300" formGroupName="10" [draggable]="false"
                        [resizable]="false" class="dialog">


                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Role</mat-label>
                          <input matInput name="role" required formControlName="role">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Name</mat-label>
                          <input matInput name="role" required formControlName="name">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Title</mat-label>
                          <input matInput name="role" required formControlName="title">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Company</mat-label>
                          <input matInput name="role" required formControlName="company">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Address</mat-label>
                          <input matInput name="role" required formControlName="address">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section" style="width: 92%; margin-left: 15px;margin-right: 15px;">
                          <mat-label>Phone</mat-label>
                          <input matInput name="role" required formControlName="phone">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Email</mat-label>
                          <input matInput name="role" required formControlName="email">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>


                          <alert></alert>
                          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button"
                            >
                            <button mat-raised-button (click)="saveOtherDesignatedContact()">
                              Save
                            </button>
                            <button mat-raised-button (click)="closeOtherDesignatedContactDialog()"
                              class="cancel-button">
                              Cancel
                            </button>
                          </div>

                      </p-dialog>

                      <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">
                        <div class="splitter" *ngIf="formArray.get([11]).controls.isFedRamp.value">FedRAMP</div>

                        <ng-container formGroupName="24">
                          <mat-form-field class="example-full-width">
                            <mat-label>Authorizing Official</mat-label>
                            <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="authorizingOfficial">
                  </textarea>
                          </mat-form-field>
                        </ng-container>

                        <p style="font-size:16px;margin: 20px 0 5px 0;">
                          <strong>
                            System Security Plan
                            Approvals
                          </strong><span class="tooltip-trigger" style="display: inline-block"
                            pTooltip='This section is only displayed in the FedRAMP template'>
                          </span>
                        </p>

                        <p-table [value]="systemSecurityPlanApprovals" [rows]="10" selectionMode="single"
                          [(selection)]="selectedSystemSecurityPlanApproval" [paginator]="true"
                          [style]="{'margin-top':'10px'}" sortField="systemSecurityPlanApprovalId"
                          #otherDesignatedContactsTable>

                          <ng-template pTemplate="caption">
                            <div class="ui-helper-clearfix">
                              <button type="button" pButton icon="pi pi-plus"
                                (click)="showDialogToAddSystemSecurityPlanApproval()" label="Add"
                                class="risksponge-button" style="float:right">
                              </button>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="header">
                            <tr>
                              <th *ngFor="let col of systemSecurityPlanApprovalCols" [pSortableColumn]="col.field"
                                [ngStyle]="{ width: col.width || 'auto' }">
                                {{ col.header }}
                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                              </th>
                              <th [ngStyle]="{width:'7em'}"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                            <tr>
                              <td>{{ item.name }}</td>
                              <td>{{ item.date | date : 'shortDate' }}</td>
                              <td>{{ item.title }}</td>
                              <td>{{ item.providerName }}</td>
                              <td>
                                <button type="button" pButton class="risksponge-button"
                                  (click)="editSystemSecurityPlanApproval(item)" icon="pi pi-pencil">
                                </button>

                                <button type="button" pButton class="risksponge-button"
                                  (click)="deleteSystemSecurityPlanApproval(item)" icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>


                        <p-dialog header="System Security Plan Approval"
                          [(visible)]="displaySystemSecurityPlanApprovalDialog"  showEffect="fade"
                          [width]="300" formGroupName="13" class="dialog">

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Name</mat-label>
                            <input matInput name="role" required formControlName="name">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Date</mat-label>
                            <input matInput name="role" required [matDatepicker]="approvalPicker"
                              formControlName="date">
                            <mat-error>This field is required</mat-error>
                            <mat-datepicker-toggle matSuffix [for]="approvalPicker"></mat-datepicker-toggle>
                            <mat-datepicker #approvalPicker></mat-datepicker>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Title</mat-label>
                            <input matInput name="role" required formControlName="title">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Cloud Service Provider Name</mat-label>
                            <input matInput name="role" required formControlName="providerName">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>


                            <alert></alert>
                            <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
                              <button mat-raised-button (click)="saveSystemSecurityPlanApproval()">
                                Save
                              </button>


                              <button mat-raised-button (click)="closeSystemSecurityPlanApprovalDialog()">
                                Cancel
                              </button>
                            </div>

                        </p-dialog>
                      </ng-container>

                      <div style="margin-top: 10px" class="save-button">

                        <button mat-raised-button (click)="onDone()">
                          Save
                        </button>
                      </div>

                    </div>

                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>Information Types & Flows </mat-panel-title>
                    <mat-panel-description>
                      Define and manage information types and data flows.
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Information Types & Flows -->
                  <div formGroupName="4" [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      Types of Information
                    </ng-template>
                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width" style="margin-top: 8px;">
                          <mat-checkbox type="text" formControlName="typesSectionVisible">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                      <div style="flex:0 0 2%"></div>
                      <div style="flex:1 1 auto">
                        <mat-form-field class="input-section" style="margin-left: 20px;">
                          <mat-label>SSP Section Name</mat-label>
                          <input matInput required formControlName="typesSectionTitle">
                        </mat-form-field>
                      </div>
                    </div>

                    <p style="font-size:16px;margin: 20px 0 5px 0; width: 70%;">
                      <strong>
                        What types of information does your company obtain,
                        develop, or
                        maintains. For example: official use (FOUO), sensitive but unclassified (SBU), and or controlled
                        unclassified information (CUI)
                      </strong>
                    </p>

                    <mat-form-field class="textarea-section" style="width: 70%;">
                      <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="typesOfInformationFormCtrl">
          </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>
                    <div class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="System">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>

                @if (currentUser?.role === Role.PlatformSupport || currentUser?.role === Role.PrimaryAdvisorLead) {
                  <mat-expansion-panel *ngIf="tenantPermissions.isElixirEnabled" (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> IT Stack </mat-panel-title>
                    <mat-panel-description>
                      Describe the technology stack supporting your system
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <ng-container formGroupName="32">
                    <h4>Product Technologies</h4>
                    <div style="width: 70%;">
                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Deployment Type</mat-label>
                        <mat-select formControlName="deploymentType">
                          <mat-option value="onPrem">On-Premise</mat-option>
                          <mat-option value="cloud">Cloud</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Primary OS</mat-label>
                        <input matInput formControlName="primaryOS" placeholder="e.g., Windows, Linux, macOS" />
                      </mat-form-field>

                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Identity Management Product</mat-label>
                        <input matInput formControlName="identityManagement" placeholder="e.g., Okta, Azure AD, Ping Identity" />
                      </mat-form-field>

                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Primary Firewall Product</mat-label>
                        <input matInput formControlName="firewallProduct" placeholder="e.g., Palo Alto, Fortinet, Cisco ASA" />
                      </mat-form-field>

                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Primary Configuration Management Product</mat-label>
                        <input matInput formControlName="configManagementProduct" placeholder="e.g., Ansible, Puppet, Chef" />
                      </mat-form-field>

                      <mat-form-field class="input-section" appearance="fill">
                        <mat-label>Primary Development Language</mat-label>
                        <input matInput formControlName="devLanguage" placeholder="e.g., Python, Java, C#" />
                      </mat-form-field>

                      <mat-form-field class="textarea-section" appearance="fill">
                        <mat-label>Security Tools Deployed</mat-label>
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                                  formControlName="securityTools"
                                  placeholder="e.g., Nessus, Wireshark, Splunk"></textarea>
                      </mat-form-field>
                      <br />
                      <mat-form-field class="textarea-section" appearance="fill">
                        <mat-label>Other Key Technologies</mat-label>
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"
                                  formControlName="otherTech1"
                                  placeholder="e.g., Docker, Kubernetes, Terraform"></textarea>
                      </mat-form-field>

                    </div>

                    <h4>Boundary Technologies</h4>
                    <div formArrayName="boundaryTechnologies">
                      @for (topic of topics; track topic.name; let i = $index) {
                        <div style="display: flex; flex-direction: row;" [formGroupName]="i">
                          <mat-label style="flex: 0 1 20%;">{{topic.name}}</mat-label>
                          <mat-select style="flex: 0 1 20%; margin-right: 20px;" placeholder="Select Service" formControlName="serviceId">
                            @for (service of groupedServices[topic.name]; track service.itemId) {
                              <mat-option [value]="service.itemId">{{service.name}}</mat-option>
                            }
                          </mat-select>
                          <mat-radio-group style="flex: 0 1 20%; white-space: nowrap;" formControlName="implementationStatus">
                            <mat-radio-button [value]="1">Implemented</mat-radio-button>
                            <mat-radio-button [value]="2">Partially</mat-radio-button>
                            <mat-radio-button [value]="7">Not Started</mat-radio-button>
                            <mat-radio-button [value]="0">NA</mat-radio-button>
                          </mat-radio-group>
                          <mat-select placeholder="Responsibility" style="flex: 0 0 120px;" formControlName="responsibility">
                            <mat-option value="Inherited">Inherited</mat-option>
                            <mat-option value="Customer">Customer</mat-option>
                            <mat-option value="Shared">Shared</mat-option>
                          </mat-select>
                          <div style="flex: 1 1 auto;"></div>
                        </div>
                      }
                    </div>

                    <mat-slide-toggle formControlName="updateProjects">Enable Project Update</mat-slide-toggle>
                    <div>
                      @for (project of mappedProjects; track project.projectId) {
                        <mat-checkbox [value]="project.projectId" (change)="toggleProject(project.projectId, $event)">{{project.name}}</mat-checkbox>
                      }
                    </div>

                    <div class="save-button" style="margin-top: 20px;">
                      <button mat-raised-button color="primary" (click)="onDone()">Save</button>
                    </div>
                  </ng-container>
                </mat-expansion-panel>
                }

                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> System & Boundary </mat-panel-title>
                    <mat-panel-description>
                      Overview and boundary information of the system
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- System & Boundary -->
                  <div>
                    <div [stepControl]="{invalid: false}">
                      <ng-template matStepLabel>
                        <div>Intro & Summary</div>
                      </ng-template>

                      <ng-container formGroupName="1">
                        <p style="font-size:14px;"><strong style="padding-right: 10px;">Information System Name</strong>
                        </p>
                        <div class="input-container" style="width:70%">
                          <mat-form-field class="input-section">
                            <mat-label>Unique Identifier</mat-label>
                            <input matInput type="text" formControlName="fedRampApplicationNumber" />
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>System Name</mat-label>
                            <input matInput type="text" formControlName="systemName" />
                            <mat-error>The input is invalid.</mat-error>
                          </mat-form-field>
                          <mat-form-field class="input-section">
                            <mat-label>System Name Abbreviation</mat-label>
                            <input matInput type="text" formControlName="systemNameAbbreviation" />
                            <mat-error>The input is invalid.</mat-error>
                          </mat-form-field>
                        </div>
                        <p style="font-size:16px;margin: 20px 0 5px 0;">
                          <strong style="padding-right: 10px;">Introduction</strong>
                        </p>
                        <div style="display: flex; flex-direction: row; width:70%">
                          <div style="flex:0 0 auto">
                            <div class="example-full-width" style="margin-top: 8px;">
                              <mat-checkbox type="text" formControlName="introSectionVisible">
                                Visible in SSP
                              </mat-checkbox>
                            </div>
                          </div>
                          <div style="flex:1 1 auto">
                            <mat-form-field class="input-section" style="margin-left: 20px;">
                              <mat-label>SSP Section Name</mat-label>
                              <input matInput required formControlName="introSectionTitle">
                            </mat-form-field>
                          </div>
                        </div>
                        <mat-form-field class="textarea-section" style="width: 70%;">
                          <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="introduction">
                    </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>
                        <p style="font-size:16px;margin: 20px 0 5px 0; width: 70%;">
                          <strong>
                            Please describe the general purpose of the system
                            including different
                            physical office/data center locations and their respective roles/purposes
                          </strong>
                        </p>
                        <mat-form-field class="textarea-section" style="width: 70%;">
                          <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="7" cdkAutosizeMaxRows="14" formControlName="generalPurposeFormCtrl">
                        </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>
                      </ng-container>

                      <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">
                        <div class="splitter" *ngIf="formArray.get([11]).controls.isFedRamp.value">FedRAMP</div>
                        <p style="font-size:16px;margin: 20px 0 5px 0;">
                          <strong>
                            Sensitivity Categorization of Information
                            Types
                          </strong><span class="tooltip-trigger" style="display: inline-block"
                            pTooltip='This section is only displayed in the FedRAMP template'>
                          </span>
                        </p>

                        <p-table [value]="sensitivityCategorizations" [rows]="10" selectionMode="single"
                          [(selection)]="selectedSensitivityCategorization" [paginator]="true"
                          [style]="{'margin-top':'10px'}" sortField="sensitivityCategorizationId"
                          #otherDesignatedContactsTable>

                          <ng-template pTemplate="caption">
                            <div class="ui-helper-clearfix">
                              <button type="button" pButton icon="pi pi-plus"
                                (click)="showDialogToAddSensitivityCategorization()" class="risksponge-button"
                                style="float:right">
                              </button>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="header">
                            <tr>
                              <th *ngFor="let col of sensitivityCategorizationCols" [pSortableColumn]="col.field"
                                [ngStyle]="{ width: col.width || 'auto' }">
                                {{ col.header }}
                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                              </th>
                              <th [ngStyle]="{width:'7em'}"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                            <tr>
                              <td>{{ item.informationType }}</td>
                              <td>{{ item.identifier }}</td>
                              <td>{{ lowMediumHigh[item.confidentiality] }}</td>
                              <td>{{ lowMediumHigh[item.integrity] }}</td>
                              <td>{{ lowMediumHigh[item.availability] }}</td>
                              <td>
                                <button type="button" pButton class="risksponge-button"
                                  (click)="editSensitivityCategorization(item)" icon="pi pi-pencil">
                                </button>

                                <button type="button" pButton class="risksponge-button"
                                  (click)="deleteSensitivityCategorization(item)" icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>


                        <p-dialog header="System Security Plan Approval"
                          [(visible)]="displaySensitivityCategorizationDialog"  showEffect="fade"
                          [width]="300" formGroupName="15" class="dialog">

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Information Type</mat-label>
                            <input matInput name="role" required formControlName="informationType">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Identifier</mat-label>
                            <input matInput name="role" required formControlName="identifier">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="example-full-width">
                            <mat-label>Confidentiality</mat-label>
                            <mat-select type="text" formControlName="confidentiality">
                              <mat-option [value]="0">Low (L)</mat-option>
                              <mat-option [value]="1">Moderate (M)</mat-option>
                              <mat-option [value]="2">High (H)</mat-option>
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field class="example-full-width">
                            <mat-label>Integrity</mat-label>
                            <mat-select type="text" formControlName="integrity">
                              <mat-option [value]="0">Low (L)</mat-option>
                              <mat-option [value]="1">Moderate (M)</mat-option>
                              <mat-option [value]="2">High (H)</mat-option>
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field class="example-full-width">
                            <mat-label>Availability</mat-label>
                            <mat-select type="text" formControlName="availability">
                              <mat-option [value]="0">Low (L)</mat-option>
                              <mat-option [value]="1">Moderate (M)</mat-option>
                              <mat-option [value]="2">High (H)</mat-option>
                            </mat-select>
                          </mat-form-field>


                            <alert></alert>
                            <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
                              <button mat-raised-button (click)="saveSensitivityCategorization()">
                                Save
                              </button>


                              <button mat-raised-button (click)="closeSensitivityCategorizationDialog()">
                                Cancel
                              </button>
                            </div>

                        </p-dialog>

                        <p style="font-size:16px;margin: 20px 0 5px 0;">
                          <strong>Leveraged Authorizations</strong><span class="tooltip-trigger"
                            style="display: inline-block"
                            pTooltip='This section is only displayed in the FedRAMP template'>
                          </span>
                        </p>

                        <p-table [value]="leveragedAuthorizations" [rows]="10" selectionMode="single"
                          [(selection)]="selectedLeveragedAuthorization" [paginator]="true"
                          [style]="{'margin-top':'10px'}" sortField="leveragedAuthorizationId"
                          #otherDesignatedContactsTable>

                          <ng-template pTemplate="caption">
                            <div class="ui-helper-clearfix">
                              <button type="button" pButton icon="pi pi-plus"
                                (click)="showDialogToAddLeveragedAuthorization()" class="risksponge-button"
                                style="float:right">
                              </button>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="header">
                            <tr>
                              <th *ngFor="let col of leveragedAuthorizationCols" [pSortableColumn]="col.field"
                                [ngStyle]="{ width: col.width || 'auto' }">
                                {{ col.header }}
                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                              </th>
                              <th [ngStyle]="{width:'7em'}"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                            <tr>
                              <td>{{ item.name }}</td>
                              <td>{{ item.owner }}</td>
                              <td>{{ item.date | date : 'shortDate' }}</td>
                               <td>{{ item.fedramp_identifier}}</td>
                              <td>
                                <button type="button" pButton class="risksponge-button"
                                  (click)="editLeveragedAuthorization(item)" icon="pi pi-pencil">
                                </button>

                                <button type="button" pButton class="risksponge-button"
                                  (click)="deleteLeveragedAuthorization(item)" icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>


                        <p-dialog header="System Security Plan Approval"
                          [(visible)]="displayLeveragedAuthorizationDialog"  showEffect="fade"
                          [width]="300" formGroupName="17" class="dialog">

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Leveraged Information System Name</mat-label>
                            <input matInput name="role" required formControlName="name">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Leveraged Service Provider Owner</mat-label>
                            <input matInput name="role" required formControlName="owner">
                            <mat-error>This field is required</mat-error>
                          </mat-form-field>

                          <mat-form-field class="dialog-control-width">
                            <mat-label>Date</mat-label>
                            <input matInput name="role" required [matDatepicker]="leveragedPicker"
                              formControlName="date">
                            <mat-error>This field is required</mat-error>
                            <mat-datepicker-toggle matSuffix [for]="leveragedPicker"></mat-datepicker-toggle>
                            <mat-datepicker #leveragedPicker></mat-datepicker>
                          </mat-form-field>
  <mat-form-field class="dialog-control-width">
    <mat-label>FedRAMP Identifier</mat-label>
    <input matInput name="fedramp_identifier" required formControlName="fedramp_identifier">
    <mat-error>This field is required</mat-error>
  </mat-form-field>


                            <alert></alert>
                            <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
                              <button mat-raised-button (click)="saveLeveragedAuthorization()">
                                Save
                              </button>
                              <button mat-raised-button (click)="closeLeveragedAuthorizationDialog()">
                                Cancel
                              </button>
                            </div>

                        </p-dialog>

                        <ng-container formGroupName="18">
                          <div style="margin-top: 20px;">
                            <mat-checkbox formControlName="isFedRampAuthorizationPlanned">
                              FedRAMP Authorization Planned
                            </mat-checkbox>
                            <p style="font-size:16px;margin: 20px 0 5px 0;"><strong>System Function Or Purpose</strong>
                            </p>
                            <mat-form-field class="example-full-width">
                              <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20"
                                formControlName="systemFunctionOrPurpose">
                          </textarea>
                              <mat-error>The input is invalid.</mat-error>
                            </mat-form-field>
                          </div>
                        </ng-container>
                      </ng-container>
                      <div class="save-button">

                        <button mat-raised-button (click)="onDone()">
                          Save
                        </button>
                      </div>
                    </div>
                    <ng-template matStepLabel>
                      System Boundary
                    </ng-template>

                    <ng-container formGroupName="5">
                      <div style="display: flex; flex-direction: row; width:70%">
                        <div style="flex:0 0 auto">
                          <div class="example-full-width" style="margin-top: 8px;">
                            <mat-checkbox type="text" formControlName="boundarySectionVisible">
                              Visible in SSP
                            </mat-checkbox>
                          </div>
                        </div>
                        <div style="flex:0 0 2%"></div>
                        <div style="flex:1 1 auto">
                          <mat-form-field class="input-section" style="margin-left: 20px;">
                            <mat-label>SSP Section Name</mat-label>
                            <input matInput required formControlName="boundarySectionTitle">
                          </mat-form-field>
                        </div>
                      </div>

                      <p style="font-size:16px;margin: 15px 0 5px 0; width: 70%;">
                        <strong>
                          a. Briefly desribe opening part of the boundary of the system as it
                          pertains to CUI and
                          include details on the types of hardware utilized at each location and their purpose
                        </strong>
                      </p>
                      <mat-form-field class="textarea-section" style="width: 70%;">
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                          cdkAutosizeMaxRows="20" type="text" formControlName="systemBoundaryPreDescriptionFormCtrl">
                          </textarea>
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>

                      <p style="font-size:16px;margin: 20px 0 5px 0;">
                        <strong>
                          b. Please attach a high level network diagram
                          depicting the
                          boundary.
                        </strong>
                      </p>
                      <div style="margin-bottom: 10px">
                        <div *ngIf="systemBoundaryDiagram == null">
                          <label class="mat-button mat-raised-button" for="systemBoundaryDiagram"  matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                            <i class="pi pi-paperclip"></i>
                            <p class="clip-text"> Attach System Boundary Diagram</p>
                            <input id="systemBoundaryDiagram"
                                   type="file"
                                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                                   (change)="addSystemBoundaryDiagramFile($event)"
                                   name="serverDiagram"
                              style="display: none;" />
                          </label>
                        </div>
                        <div *ngIf="systemBoundaryDiagram != null">
                          <span (click)="downloadSystemBoundaryDiagramFile()" class="btn btn-link">
                            <img style="max-width: 100px; max-height: 100px;"
                              [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.systemBoundaryDiagram) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                            {{ systemBoundaryDiagram }}
                          </span>
                          <label class="mat-button mat-raised-button" for="updateSystemBoundaryDiagramFile">
                            <i class="pi pi-paperclip"></i>
                            <p class="clip-text">Upload new file</p>
                            <input id="updateSystemBoundaryDiagramFile" type="file" accept=".pdf,image/*"
                              (change)="addSystemBoundaryDiagramFile($event)" name="updateSystemBoundaryDiagramFile"
                              style="display: none;" />
                          </label>
                          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                            [title]="'Remove System Boundary Diagram'"
                            [popoverMessage]="'You are going to remove System Boundary Diagram. It is required for SSP generation. Are you sure?'"
                            [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                            (confirm)="systemBoundaryDiagram=null">
                            <i class="pi pi-trash"></i>
                            <p class="clip-text"> Remove System Boundary Diagram</p>
                          </label>
                        </div>
                      </div>
                      <p style="font-size:16px;margin: 20px 0 5px 0; width: 70%;">
                        <strong>
                          c. Briefly desribe the boundary of the system as it
                          pertains to CUI and
                          include details on the types of hardware utilized at each location and their purpose
                        </strong>
                      </p>
                      <mat-form-field class="textarea-section" style="width: 70%;">
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                          cdkAutosizeMaxRows="20" type="text" formControlName="systemBoundaryDescriptionFormCtrl">
                          </textarea>
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>
                      <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">
                        <div class="splitter" *ngIf="formArray.get([11]).controls.isFedRamp.value">FedRAMP</div>
                        <p style="font-size:16px;margin: 20px 0 5px 0;"><strong>Data Flow Description</strong></p>
                        <mat-form-field class="example-full-width">
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                            cdkAutosizeMaxRows="20" type="text" formControlName="dataFlowDescription">
                          </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>
                        <p style="font-size:16px;margin: 20px 0 5px 0;"><strong>System Environment and
                            Inventory</strong>
                        </p>
                        <mat-form-field class="example-full-width">
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                            cdkAutosizeMaxRows="20" type="text" formControlName="systemEnvironmentAndInventory">
                          </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <div style="margin-bottom: 10px">
                          <div *ngIf="dataFlowDiagram == null">
                            <label class="mat-button mat-raised-button" for="dataFlowDiagram">
                              <i class="pi pi-paperclip"></i> Attach Data Flow Diagram
                              <input id="dataFlowDiagram" type="file" (change)="addDataFlowDiagramFile($event)"
                                name="dataFlowDiagram" style="display: none;" />
                            </label>
                          </div>
                          <div *ngIf="dataFlowDiagram != null">
                            <span (click)="downloadDataFlowDiagramFile()" class="btn btn-link">
                              <img style="max-width: 100px; max-height: 100px;"
                                [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.dataFlowDiagram) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                              {{ dataFlowDiagram }}
                            </span>
                            <label class="mat-button mat-raised-button" for="updateDataFlowDiagramFile">
                              <i class="pi pi-paperclip"></i> Upload new file
                              <input id="updateDataFlowDiagramFile" type="file"
                                (change)="addDataFlowDiagramFile($event)" name="updateDataFlowDiagramFile"
                                style="display: none;" />
                            </label>
                            <label class="mat-button mat-raised-button" mwlConfirmationPopover
                              [title]="'Remove Data Flow Diagram'"
                              [popoverMessage]="'You are going to remove Data Flow Diagram. It is required for FedRAMP SSP generation. Are you sure?'"
                              [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                              (confirm)="dataFlowDiagram=null">
                              <i class="pi pi-trash"></i>
                              Remove Data Flow Diagram
                            </label>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                    <div class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Environment</mat-panel-title>
                    <mat-panel-description>
                      Details specific to the environment
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Environment -->
                  <div formGroupName="7" [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      Environment Description
                    </ng-template>
                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width" style="margin-top: 8px;">
                          <mat-checkbox type="text" formControlName="environmentSectionVisible">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                      <div style="flex:0 0 2%"></div>
                      <div style="flex:1 1 auto">
                        <mat-form-field class="input-section" style="margin-left: 20px;">
                          <mat-label>SSP Section Name</mat-label>
                          <input matInput required formControlName="environmentSectionTitle">
                        </mat-form-field>
                      </div>
                    </div>

                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        a. Describe the system environment including the applications at each
                        location within the boundary, the personnel that use each application, and how they access the
                        applications and/or resources i.e. share drives, printing, etc.
                      </strong>
                    </p>
                    <mat-form-field class="textarea-section" style="width: 70%;">
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                        cdkAutosizeMaxRows="20" type="text" formControlName="systemEnvironmentDescriptionFormCtrl">
          </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>
                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        b. Please attach a diagram showing the major servers housing the
                        applications for the system boundary.
                      </strong>
                    </p>

                    <div style="margin-bottom: 10px">
                      <div *ngIf="serverDiagram == null">
                        <label class="mat-button mat-raised-button" for="serverDiagram">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Attach Server Diagram</p>
                          <input id="serverDiagram" type="file" (change)="addServerDiagramFile($event)"
                            name="serverDiagram" style="display: none;" />
                        </label>
                      </div>
                      <div *ngIf="serverDiagram != null">
                        <span (click)="downloadServerDiagramFile()" class="btn btn-link">
                          <img style="max-width: 100px; max-height: 100px;"
                            [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.serverDiagram) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                          {{ serverDiagram }}
                        </span>
                        <label class="mat-button mat-raised-button" for="updateServerDiagramFile">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new file</p>
                          <input id="updateServerDiagramFile" type="file" (change)="addServerDiagramFile($event)"
                            name="updateServerDiagramFile" style="display: none;" />
                        </label>
                        <label class="mat-button mat-raised-button" mwlConfirmationPopover
                          [title]="'Remove Server Diagram'"
                          [popoverMessage]="'You are going to remove Server Diagram. It is required for SSP generation. Are you sure?'"
                          [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                          (confirm)="serverDiagram=null">
                          <i class="pi pi-trash"></i>
                          <p class="clip-text"> Remove Server Diagram</p>
                        </label>
                      </div>
                    </div>

                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        c. Please list the key role/functionality for each server in the
                        diagram
                      </strong>
                    </p>
                    <mat-form-field class="textarea-section" style="width: 70%">
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                        cdkAutosizeMaxRows="20" type="text" formControlName="serverDescriptionsFormCtrl">
              </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>

                    <div class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>



                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="Network & Access">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Network </mat-panel-title>
                    <mat-panel-description>
                      Network-related information
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Network -->
                  <div formGroupName="8" [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      Network Diagram
                    </ng-template>
                    <div>
                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 auto">
                          <div class="example-full-width" style="margin-top: 8px;">
                            <mat-checkbox type="text" formControlName="networkSectionVisible">
                              Visible in SSP
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p style="font-size:16px; width: 70%;"><strong>a. Please provide a description of first office
                        network</strong></p>
                    <mat-form-field class="textarea-section" style="width: 70%;">
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                        cdkAutosizeMaxRows="10" type="text" formControlName="networkDescriptionFormCtrl1">
          </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>
                    <p style="font-size:16px;  width: 70%;">
                      <strong>
                        b. Please attach a corresponding detailed first network diagram for each
                        location within the system boundary (if exists)
                      </strong>
                    </p>
                    <div style="margin-bottom: 10px">
                      <div *ngIf="detailedNetworkDiagram1 == null">
                        <label class="mat-button mat-raised-button" for="addDetailedNetworkDiagramFile1">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Attach Network Diagram 1</p>
                          <input id="addDetailedNetworkDiagramFile1" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 1)" name="addDetailedNetworkDiagramFile1"
                            style="display: none;" />
                        </label>
                      </div>
                      <div *ngIf="detailedNetworkDiagram1 != null">
                        <span (click)="downloadDetailedNetworkDiagramFile(1)" class="btn btn-link">
                          <img style="max-width: 100px; max-height: 100px;"
                            [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.detailedNetworkDiagram1) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                          {{ detailedNetworkDiagram1 }}
                        </span>
                        <label class="mat-button mat-raised-button" for="updateDetailedNetworkDiagramFile1">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new Network Diagram 1</p>
                          <input id="updateDetailedNetworkDiagramFile1" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 1)" name="updateDetailedNetworkDiagramFile1"
                            style="display: none;" />
                        </label>
                        <label class="mat-button mat-raised-button" mwlConfirmationPopover
                          [title]="'Remove Network Diagram 1'"
                          [popoverMessage]="'You are going to remove Network Diagram 1. Are you sure?'"
                          [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                          (confirm)="detailedNetworkDiagram1=null">
                          <i class="pi pi-trash"></i>
                          <p class="clip-text">Remove Network Diagram 1</p>
                        </label>
                      </div>
                    </div>

                    <p style="font-size:16px; width: 70%;"><strong>c. Please provide a description of second office
                        network</strong></p>
                    <mat-form-field class="textarea-section" style="width: 70%;">
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                        cdkAutosizeMaxRows="10" type="text" formControlName="networkDescriptionFormCtrl2">
          </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>
                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        d. Please attach a corresponding detailed second network diagram for each
                        location within the system boundary (if exists)
                      </strong>
                    </p>
                    <div style="margin-bottom: 10px">
                      <div *ngIf="detailedNetworkDiagram2 == null">
                        <label class="mat-button mat-raised-button" for="addDetailedNetworkDiagramFile2">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Attach Server Diagram 2</p>
                          <input id="addDetailedNetworkDiagramFile2" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 2)" name="addDetailedNetworkDiagramFile2"
                            style="display: none;" />
                        </label>
                      </div>
                      <div *ngIf="detailedNetworkDiagram2 != null">
                        <span (click)="downloadDetailedNetworkDiagramFile(2)" class="btn btn-link">
                          <img style="max-width: 100px; max-height: 100px;"
                            [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.detailedNetworkDiagram2) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                          {{ detailedNetworkDiagram2 }}
                        </span>
                        <label class="mat-button mat-raised-button" for="updateDetailedNetworkDiagramFile2">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new Network Diagram 1</p>
                          <input id="updateDetailedNetworkDiagramFile2" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 2)" name="updateDetailedNetworkDiagramFile2"
                            style="display: none;" />
                        </label>
                        <label class="mat-button mat-raised-button" mwlConfirmationPopover
                          [title]="'Remove Network Diagram 2'"
                          [popoverMessage]="'You are going to remove Network Diagram 2. Are you sure?'"
                          [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                          (confirm)="detailedNetworkDiagram2=null">
                          <i class="pi pi-trash"></i>
                          <p class="clip-text"> Remove Network Diagram 2</p>
                        </label>
                      </div>
                    </div>

                    <p style="font-size:16px; width: 70%;"><strong>e. Please provide a description of third office
                        network</strong></p>
                    <mat-form-field class="textarea-section" style="width: 70%;">
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                        cdkAutosizeMaxRows="10" type="text" formControlName="networkDescriptionFormCtrl3">
          </textarea>
                      <mat-error>The input is invalid.</mat-error>
                    </mat-form-field>
                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        f. Please attach a corresponding detailed third network diagram for each
                        location within the system boundary (if exists)
                      </strong>
                    </p>
                    <div style="margin-bottom: 10px">
                      <div *ngIf="detailedNetworkDiagram3 == null">
                        <label class="mat-button mat-raised-button" for="addDetailedNetworkDiagramFile3">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Attach Network Diagram 3</p>
                          <input id="addDetailedNetworkDiagramFile3" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 3)" name="addDetailedNetworkDiagramFile3"
                            style="display: none;" />
                        </label>
                      </div>
                      <div *ngIf="detailedNetworkDiagram3 != null">
                        <span (click)="downloadDetailedNetworkDiagramFile(3)" class="btn btn-link">
                          <img style="max-width: 100px; max-height: 100px;"
                            [attr.src]="api + '/api/attachments/file?name='+ window.encodeURIComponent(this.detailedNetworkDiagram3) + '&asImage=true&path=Account/IT%20Profile&token=' + token" />
                          {{ detailedNetworkDiagram3 }}
                        </span>
                        <label class="mat-button mat-raised-button" for="updateDetailedNetworkDiagramFile3">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new Network Diagram 3</p>
                          <input id="updateDetailedNetworkDiagramFile3" type="file"
                            (change)="addDetailedNetworkDiagramFile($event, 3)" name="updateDetailedNetworkDiagramFile3"
                            style="display: none;" />
                        </label>
                        <label class="mat-button mat-raised-button" mwlConfirmationPopover
                          [title]="'Remove Network Diagram 3'"
                          [popoverMessage]="'You are going to remove Network Diagram 3. Are you sure?'"
                          [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                          (confirm)="detailedNetworkDiagram3=null">
                          <i class="pi pi-trash"></i>
                          <p class="clip-text"> Remove Network Diagram 3</p>
                        </label>
                      </div>
                    </div>

                    <div class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> System Roles</mat-panel-title>
                    <mat-panel-description>
                      Define and manage system roles
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- System Roles -->
                  <div [stepControl]="{invalid: false}" class="client-profile">
                    <ng-template matStepLabel>
                      System Roles
                    </ng-template>

                    <ng-container formGroupName="19">
                      <p style="font-size:16px;margin: 5px 0 20px 0;">
                        <strong>
                          Please fill in the table with information on the
                          different types of user
                          roles
                          supported by your system along with their respective access permission and authorized
                          functions
                        </strong>
                      </p>
                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 auto">
                          <div class="example-full-width" style="margin-top: 8px;">
                            <mat-checkbox type="text" formControlName="rolesSectionVisible">
                              Visible in SSP
                            </mat-checkbox>
                          </div>
                        </div>
                        <div style="flex:0 0 2%"></div>
                        <div style="flex:1 1 auto">
                          <mat-form-field class="input-section" style="margin-left: 20px;">
                            <mat-label>SSP Section Name</mat-label>
                            <input matInput required formControlName="rolesSectionTitle">
                          </mat-form-field>
                        </div>
                      </div>
                    </ng-container>
                    <p-table [value]="roles" [rows]="5" selectionMode="single" [(selection)]="selectedRole"
                             [paginator]="true" [style]="{'margin-top':'10px'}" sortField="systemRolePrivilegeId"
                             #systemRolesTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddRole()"
                                  class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of rolesCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'6em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.role }}</td>
                          <td>{{ item.isInternal }}</td>
                          <td>{{ getAccessLabel(item.access) }}</td>
                          <td>{{ item.sensitivityLevel }}</td>
                          <td>{{ item.authorizedPrivileges }}</td>
                          <td>{{ item.authorizedFunctionsPerformed }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button" (click)="onRoleEdit(item)"
                                    icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button" (click)="onRoleDelete(item)"
                                    icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>


                    <p-dialog header="Role and Privileges" [(visible)]="displayRoleDialog"
                              showEffect="fade" formGroupName="6" [width]="300" [draggable]="false" [resizable]="false"
                              class="dialog">
                      <div style="display: grid;  width: 350px;">
                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Role</mat-label>
                          <input matInput name="role" required formControlName="roleFormChildCtrl">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Select Access</mat-label>
                          <mat-select formControlName="accessFormChildCtrl">
                            <mat-option [value]="1">Privileged</mat-option>
                            <mat-option [value]="2">Non-Privileged</mat-option>
                            <mat-option [value]="3">No Logical Acceess</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Select Access</mat-label>
                          <mat-select formControlName="sensitivityLevel">
                            <mat-option [value]="0">NA</mat-option>
                            <mat-option [value]="1">High Risk</mat-option>
                            <mat-option [value]="2">Severe</mat-option>
                            <mat-option [value]="3">Moderate</mat-option>
                            <mat-option [value]="4">Limited</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Authorized Privileges</mat-label>
                          <input matInput name="role" required formControlName="authorizedPrivileges">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Authorized Functions Performed</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                                    cdkAutosizeMaxRows="10" type="text" required
                                    formControlName="authorizedFunctionsPerformedFormChildCtrl">
                            </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>
                        <div class="example-full-width">
                          <mat-checkbox style="margin-top: 5px;" formControlName="isInternal">
                            Internal or External
                          </mat-checkbox>
                        </div>
                      </div>

                      <alert></alert>
                      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button">
                        <button mat-raised-button (click)="saveRole()">
                          Save
                        </button>


                        <button mat-raised-button class="cancel-button" (click)="closeRoleDialog()">
                          Cancel
                        </button>
                      </div>

                    </p-dialog>
                    <div style="margin-top: 15px;">
                      <ng-container formGroupName="19">
                        <div>
                          There are currently
                          <div style="display: inline-block!important ; margin-left: 6px;">
                            <mat-form-field class="input-section" style="width: 100px;">
                              <mat-label>Internal Count</mat-label>
                              <input matInput type="number" formControlName="internalCount" />
                            </mat-form-field>
                          </div>
                          internal personnel and
                          <div style="display: inline-block!important ; margin-left: 6px;">
                            <mat-form-field class="input-section" style="width: 100px;">
                              <mat-label>External Count</mat-label>
                              <input matInput type="text" formControlName="externalCount" />
                            </mat-form-field>
                          </div>
                          external personnel. Within one year, it is anticipated that there will be
                          <div style="display: inline-block!important ; margin-left: 6px;">
                            <mat-form-field class="input-section" style="width: 100px;">
                              <mat-label>Internal Next Year Count</mat-label>
                              <input matInput type="text" formControlName="internalNextYearCount" />
                            </mat-form-field>
                          </div>
                          internal personnel and
                          <div style="display: inline-block!important ; margin-left: 6px;">
                            <mat-form-field class="input-section" style="width: 100px;">
                              <mat-label>External Next Year Count</mat-label>
                              <input matInput type="text" formControlName="externalNextYearCount" />
                            </mat-form-field>
                          </div>
                          external personnel.
                        </div>
                      </ng-container>
                    </div>
                    <h4>System Users</h4>
                    <p-table [value]="systemUsers" [rows]="5" selectionMode="single" [(selection)]="selectedSystemUser"
                             [paginator]="true" [style]="{'margin-top':'10px'}" sortField="systemUserId"
                             #systemUsersTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddSystemUser()"
                                  class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of systemUsersCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'6em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.name }}</td>
                          <td>{{ item.role }}</td>
                          <td>{{ item.reviewedDate | date : 'shortDate' }}</td>
                          <td>{{ item.lastLoginDate | date : 'shortDate' }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button" (click)="onSystemUserEdit(item)"
                                    icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button" (click)="onSystemUserDelete(item)"
                                    icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>


                    <p-dialog header="System Users" [(visible)]="displaySystemUserDialog"
                              showEffect="fade" formGroupName="33" [width]="300" [draggable]="false" [resizable]="false"
                              class="dialog">
                      <div style="display: grid;  width: 350px;">
                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Name</mat-label>
                          <input matInput name="Name" required formControlName="name">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Role</mat-label>
                          <input matInput name="Rome" required formControlName="role">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Reviewed</mat-label>
                          <input matInput
                                 [matDatepicker]="pickerReviewedDate"
                                 formControlName="reviewedDate"
                                 required />
                          <mat-datepicker-toggle matSuffix
                                                 [for]="pickerReviewedDate"></mat-datepicker-toggle>
                          <mat-datepicker #pickerReviewedDate></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Last Login</mat-label>
                          <input matInput
                                 [matDatepicker]="pickerLastLoginDate"
                                 formControlName="lastLoginDate"
                                 required />
                          <mat-datepicker-toggle matSuffix
                                                 [for]="pickerLastLoginDate"></mat-datepicker-toggle>
                          <mat-datepicker #pickerLastLoginDate></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <alert></alert>
                      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button">
                        <button mat-raised-button (click)="saveSystemUser()">
                          Save
                        </button>


                        <button mat-raised-button class="cancel-button" (click)="closeSystemUserDialog()">
                          Cancel
                        </button>
                      </div>

                    </p-dialog>
                    <h4>Separated Users</h4>
                    <p-table [value]="separatedUsers" [rows]="5" selectionMode="single" [(selection)]="selectedSeparatedUser"
                             [paginator]="true" [style]="{'margin-top':'10px'}" sortField="separatedUserId"
                             #separatedUsersTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-cog" (click)="showSeparatedUserIntegrationsDialog()"
                                  class="risksponge-button" style="float:right">
                          </button>
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddSeparatedUser()"
                                  class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of separatedUsersCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'20em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.name }}</td>
                          <td>{{ item.separationDate | date : 'shortDate' }}</td>
                          <td>
                            <mat-select [(ngModel)]="item.accessRevoked" [ngModelOptions]="{standalone: true}">
                              <mat-option [value]="false">No</mat-option>
                              <mat-option [value]="true">Yes</mat-option>
                            </mat-select>
                          </td>
                          <td>{{ item.revokationDate | date : 'shortDate' }}</td>
                          <td>
                            @if (item.signedName) {
                            {{ item.signedDate | date : 'shortDate' }}
                            } @else {
                            Needs Review
                            }
                          </td>
                          <td>
                            <button type="button" pButton class="risksponge-button" (click)="onSeparatedUserEdit(item)"
                                    icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button" (click)="onSeparatedUserDelete(item)"
                                    icon="pi pi-trash">
                            </button>

                            <button type="button" pButton class="risksponge-button" (click)="sign(item)"
                                    icon="pi pi-credit-card">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>

                    <p-dialog header="Integrations" [(visible)]="displaySeparatedUserIntegrationsDialog"
                              showEffect="fade" [width]="300" [draggable]="false" [resizable]="false"
                              class="dialog">
                      <div style="width: 350px; height: 150px; overflow-y: auto;" class="checkbox-list">
                        <div *ngFor="let option of integrations" class="checkbox-row">
                          <label>
                            <input type="checkbox"
                                   [checked]="separatedUserIntegrations.includes(option.id)"
                                   (change)="separatedUserIntegrationsChange(option.id, $event.checked)" />
                            {{ option.name }}
                          </label>
                        </div>
                      </div>

                      <alert></alert>
                      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button">
                        <button mat-raised-button (click)="saveSeparatedUserIntegrations()">
                          Save
                        </button>


                        <button mat-raised-button class="cancel-button" (click)="closeSeparatedUserIntegrationsDialog()">
                          Cancel
                        </button>
                      </div>

                    </p-dialog>

                    <p-dialog header="Separated Users" [(visible)]="displaySeparatedUserDialog"
                              showEffect="fade" formGroupName="34" [width]="300" [draggable]="false" [resizable]="false"
                              class="dialog">
                      <div style="display: grid;  width: 350px;">
                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Name</mat-label>
                          <input matInput name="Name" required formControlName="name">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Separation Date</mat-label>
                          <input matInput
                                 [matDatepicker]="pickerSeparationDate"
                                 formControlName="separationDate"
                                 required />
                          <mat-datepicker-toggle matSuffix
                                                 [for]="pickerSeparationDate"></mat-datepicker-toggle>
                          <mat-datepicker #pickerSeparationDate></mat-datepicker>
                        </mat-form-field>

                        <mat-checkbox formControlName="accessRevoked">Access Revoked</mat-checkbox>

                        <mat-form-field class="input-section"
                                        style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Last Login</mat-label>
                          <input matInput
                                 [matDatepicker]="pickerRevokationDate"
                                 formControlName="revokationDate"
                                 required />
                          <mat-datepicker-toggle matSuffix
                                                 [for]="pickerRevokationDate"></mat-datepicker-toggle>
                          <mat-datepicker #pickerRevokationDate></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <alert></alert>
                      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button">
                        <button mat-raised-button (click)="saveSeparatedUser()">
                          Save
                        </button>


                        <button mat-raised-button class="cancel-button" (click)="closeSeparatedUserDialog()">
                          Cancel
                        </button>
                      </div>

                    </p-dialog>
                    <div style="margin-top: 10px" class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> System Interconnections</mat-panel-title>
                    <mat-panel-description>
                      Manage system interconnections
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- System Interconnections -->
                  <div>
                    <ng-template matStepLabel>
                      System Interconnections
                    </ng-template>
                    <p style="font-size:16px; width: 70%;">
                      <strong>
                        Please list system interconnection points in the table below including
                        nature
                        of the connection, points of contact, security method, content, and tranport details.
                      </strong>
                    </p>
                    <ng-container formGroupName="9">
                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 auto">
                          <div class="example-full-width" style="margin-top: 8px;">
                            <mat-checkbox type="text" formControlName="interconnectionSectionVisible">
                              Visible in SSP
                            </mat-checkbox>
                          </div>
                        </div>
                        <div style="flex:0 0 2%"></div>
                        <div style="flex:1 1 auto">
                          <mat-form-field class="input-section" style="margin-left: 20px;">
                            <mat-label>SSP Section Name</mat-label>
                            <input matInput required formControlName="interconnectionSectionTitle">
                          </mat-form-field>
                        </div>
                      </div>
                    </ng-container>

                    <p-table [value]="interconnections" [rows]="5" selectionMode="single"
                      [(selection)]="selectedInterconnection" [paginator]="true" [style]="{'margin-top':'10px'}"
                      sortField="systemInterconnectionId" #interconnectionsTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddInterconnection()"
                            class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr [ngStyle]="{'font-weight': 'bold'}">
                          <th *ngFor="let col of interconnectionsCols" [pSortableColumn]="col.field">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th style="width: 8em"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.addressAndInterface }}</td>
                          <td>{{ item.externalOrgName }}</td>
                          <td>{{ item.externalPointOfContact }}</td>
                          <td>{{ item.connectionSecurity }}</td>
                          <td>{{ getDataDirection(item.dataDirection) }}</td>
                          <td>{{ item.informationBeingTransmitted }}</td>
                          <td>{{ item.portOrCircuitNumbers }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button"
                              (click)="onInterconnectionEdit(item)" icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                              (click)="onInterconnectionDelete(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>


                    <p-dialog header="System Interconnections" [(visible)]="displayInterconnectionDialog"
                       showEffect="fade" [width]="500" formGroupName="21" [draggable]="false"
                      [resizable]="false" class="dialog">
                      <div style="width: 550px;">
                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>SP* IP Address and Interface</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required formControlName="addressAndInterface">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>External Organization Name and IP Address of System</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required formControlName="externalOrgNameFormChildCtrl">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>External Point of Contact and Phone Number</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required
                            formControlName="externalPointOfContactFormChildCtrl">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Connection Security (IPSec VPN, SSL, Certificates, Secure File Tranfer,
                            etc.)</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required
                            formControlName="connectionSecurityFormChildCtrl">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <div class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px; margin-bottom: 10px;">
                          <p-select [style]="{'overflow':'visible', 'width':'256px'}" [options]="dataDirectionList"
                            optionLabel="label" id="dataDirection" placeholder="Select Data Direction"
                            formControlName="dataDirectionFormChildCtrl">
                          </p-select>
                        </div>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Information Being Transmitted</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required
                            formControlName="informationBeingTransmittedFormChildCtrl">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 92%; margin-left: 15px; margin-right: 15px;">
                          <mat-label>Port or Circuit Numbers</mat-label>
                          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10" type="text" required
                            formControlName="portOrCircuitNumbersFormChildCtrl">
                              </textarea>
                          <mat-error>The input is invalid.</mat-error>
                        </mat-form-field>
                      </div>


                        <alert></alert>
                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button"
                          >
                          <button mat-raised-button (click)="saveInterconnection()">
                            Save
                          </button>

                          <button mat-raised-button class="cancel-button" (click)="closeInterconnectionDialog()">
                            Cancel
                          </button>
                        </div>

                    </p-dialog>

                    <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">
                      <div class="splitter" *ngIf="formArray.get([11]).controls.isFedRamp.value">FedRAMP</div>
                      <p style="font-size:16px;">
                        <strong>
                          Ports, Protocols and Services
                          Types
                        </strong><span class="tooltip-trigger" style="display: inline-block"
                          pTooltip='This section is only displayed in the FedRAMP template'>
                        </span>
                      </p>

                      <p-table [value]="portProtocolServices" [rows]="10" selectionMode="single"
                        [(selection)]="selectedPortProtocolService" [paginator]="true" [style]="{'margin-top':'10px'}"
                        sortField="portProtocolServiceId" #otherDesignatedContactsTable>

                        <ng-template pTemplate="caption">
                          <div class="ui-helper-clearfix">
                            <button type="button" pButton icon="pi pi-plus"
                              (click)="showDialogToAddPortProtocolService()" class="risksponge-button"
                              style="float:right">
                            </button>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                          <tr>
                            <th *ngFor="let col of portProtocolServiceCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                              {{ col.header }}
                              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <th [ngStyle]="{width:'7em'}"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                          <tr>
                            <td>{{ item.ports }}</td>
                            <td>{{ item.protocols }}</td>
                            <td>{{ item.service }}</td>
                            <td>{{ item.reference }}</td>
                            <td>{{ item.purpose }}</td>
                            <td>{{ item.usedBy }}</td>
                            <td>
                              <button type="button" pButton class="risksponge-button"
                                (click)="editPortProtocolService(item)" icon="pi pi-pencil">
                              </button>

                              <button type="button" pButton class="risksponge-button"
                                (click)="deletePortProtocolService(item)" icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>


                      <p-dialog header="System Security Plan Approval" [(visible)]="displayPortProtocolServiceDialog"
                         showEffect="fade" [width]="300" formGroupName="20" class="dialog">

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Ports (TCP/UDP)</mat-label>
                          <input matInput name="role" required formControlName="ports">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Protocols</mat-label>
                          <input matInput name="role" required formControlName="protocols">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Services</mat-label>
                          <input matInput name="role" required formControlName="service">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Reference #</mat-label>
                          <input matInput name="role" required formControlName="reference">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Purpose</mat-label>
                          <input matInput name="role" required formControlName="purpose">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="dialog-control-width">
                          <mat-label>Used By</mat-label>
                          <input matInput name="role" required formControlName="usedBy">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>


                          <alert></alert>
                          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
                            <button mat-raised-button (click)="savePortProtocolService()">
                              Save
                            </button>


                            <button mat-raised-button (click)="closePortProtocolServiceDialog()">
                              Cancel
                            </button>
                          </div>

                      </p-dialog>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Diagrams </mat-panel-title>
                    <mat-panel-description>
                      3D Models and Diagrams
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div>
                    <label class="mat-button mat-raised-button" for="addDiagram3dFile">
                      <i class="pi pi-paperclip"></i>
                      <p class="clip-text">Attach Diagram</p>
                      <input id="addDiagram3dFile" type="file"
                             (change)="addDiagramFile($event)" name="addDiagram3dFile"
                             style="display: none;" />
                    </label>
                  </div>
                  @for (diagram of diagrams; track diagram.id) {
                    <div>
                      <div>
                        <span style="margin-right: 20px;">{{diagram.name}}</span>
                        <mat-radio-button style="margin-right: 20px;" [checked]="diagram.isDefault" (change)="updateDefaultDiagram(diagram)">Make default</mat-radio-button>
                        <i class="pi pi-trash" style="cursor: pointer;" (click)="deleteDiagram(diagram)"></i>
                      </div>
                      @if(diagram.diagram3dUrls) {
                        <div *ngIf="diagram.diagram3d != null">
                          <viewer-3d [modelUrls]="diagram.diagram3dUrls"></viewer-3d>
                        </div>
                      } @else {
                        <img style="max-width: 100%" [src]="diagram.imageUrl" />
                      }
                    </div>
                  }
                  <div style="margin-top: 10px" class="save-button">

                    <button mat-raised-button (click)="onDone()">
                      Save
                    </button>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="Inventory">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Name & Identifiers </mat-panel-title>
                    <mat-panel-description>
                      Provide names and identifiers
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Name & Identifiers -->
                  <div formGroupName="2" [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      Names & Identifiers
                    </ng-template>
                    <p style="font-size:14px;margin: 0px 0 5px 0;">
                      <span class="tooltip-trigger"
                        style="display: inline-block;margin-left: 10px; width: 20px; height: 20px;"
                        pTooltip='This section is only displayed in the Standard w/ Recs template'>

                      </span>
                    </p>
                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width" style="margin-top: 8px;">
                          <mat-checkbox type="text" formControlName="namesSectionVisible">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                      <div style="flex:0 0 2%"></div>
                      <div style="flex:1 1 auto">
                        <mat-form-field class="input-section" style="margin-left: 20px;">
                          <mat-label>SSP Section Name</mat-label>
                          <input matInput required formControlName="namesSectionTitle">
                        </mat-form-field>
                      </div>
                    </div>
                    <p-table [value]="namesAndIdentifiers" [rows]="10" selectionMode="single"
                      [(selection)]="selectedNameAndIdentifier" [paginator]="true" [style]="{'margin-top':'10px'}"
                      sortField="nameAndIdentifierId" #namesAndIdentifiersTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddNameAndIdentifier()"
                            class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of namesAndIdentifiersCols" [pSortableColumn]="col.field"
                            [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.systemName }}</td>
                          <td>{{ item.systemNameAbbreviation }}</td>
                          <td>{{ nameAndIdentifierTypes[item.type] }}</td>
                          <td>{{ item.description }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button"
                              (click)="onNameAndIdentifierEdit(item)" icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                              (click)="onNameAndIdentifierDelete(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>


                    <p-dialog header="Name and Identifier" [(visible)]="displayNameAndIdentifierDialog"
                       showEffect="fade" [width]="300" [draggable]="false" [resizable]="false"
                      class="dialog">

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>System or Vendor Name</mat-label>
                        <input matInput name="role" required formControlName="systemName">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>System Name Abbreviation</mat-label>
                        <input matInput name="role" required formControlName="systemNameAbbreviation">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Type</mat-label>
                        <mat-select name="role" required formControlName="type">
                          <mat-option [value]="0" pTooltip="Assets that process, store, and/or transmit CUIS">
                            CUI Asset
                          </mat-option>
                          <mat-option [value]="1"
                            pTooltip="e.g., Consultants who provide cybersecurity service; Managed service provider personnel who perform system maintenance; IT and network administrators">
                            SPA - People
                          </mat-option>
                          <mat-option [value]="2"
                            pTooltip="e.g., Directory Sevices; Hosted Virtual public Network (VPN) services; SIEM solutions">
                            SPA - Technology
                          </mat-option>
                          <mat-option [value]="3" pTooltip="e.g., Co-located data centers; Contractor office buildings">
                            SPA -
                            Facility
                          </mat-option>
                          <mat-option [value]="4"
                            pTooltip="Assets that are capable of, but are not intended to process, store and/or transmit CUI. They are managed by organizational security policy & procedures. They are not assessed against CMMC-specific controls.">
                            Contractor Risk Managed Asset (CRMA)
                          </mat-option>
                          <mat-option [value]="5"
                            pTooltip="Includes GFE, IOT, and OT. They are managed by organizational security policy & procedures. They are not assessed against CMMC-specific controls.">
                            Specialized Asset (SA)
                          </mat-option>
                          <mat-option [value]="6"
                            pTooltip="Assets that are physically or logically separated from CUI Assets and do not provide “security protections” to CUI Assets. They are out-of-scope for CMMC.">
                            Out of Scope Asset (OSA)
                          </mat-option>
                        </mat-select>
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Description</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                          cdkAutosizeMaxRows="10" type="text" required formControlName="description">
              </textarea>
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>

                        <alert></alert>
                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button"
                          >
                          <button mat-raised-button (click)="saveNameAndIdentifier()">
                            Save
                          </button>


                          <button mat-raised-button class="cancel-button" (click)="closeNameAndIdentifierDialog()">
                            Cancel
                          </button>
                        </div>

                    </p-dialog>

                    <ng-container *ngIf="formArray.get([11]).controls.isFedRamp.value">
                      <div class="splitter">FedRAMP</div>
                      <p style="font-size:16px;margin: 20px 0 5px 0;">
                        <strong>Laws and Regulations</strong><span class="tooltip-trigger" style="display: inline-block"
                          pTooltip='This section is only displayed in the FedRAMP template'>
                        </span>
                      </p>

                      <p-table [value]="lawAndRegulations" [rows]="10" selectionMode="single"
                        [(selection)]="selectedLawAndRegulation" [paginator]="true" [style]="{'margin-top':'10px'}"
                        sortField="lawAndRegulationId" #otherDesignatedContactsTable>

                        <ng-template pTemplate="caption">
                          <div class="ui-helper-clearfix">
                            <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddLawAndRegulation()"
                              class="risksponge-button" style="float:right">
                            </button>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                          <tr>
                            <th *ngFor="let col of lawAndRegulationCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                              {{ col.header }}
                              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <th [ngStyle]="{width:'7em'}"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                          <tr>
                            <td>{{ item.identificationNumber }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ item.date | date : 'shortDate' }}</td>
                            <td>{{ item.link }}</td>
                            <td>
                              <button type="button" pButton class="risksponge-button"
                                (click)="editLawAndRegulation(item)" icon="pi pi-pencil">
                              </button>

                              <button type="button" pButton class="risksponge-button"
                                (click)="deleteLawAndRegulation(item)" icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>


                      <p style="font-size:16px;margin: 20px 0 5px 0;">
                        <strong>Standards and Guidance</strong><span class="tooltip-trigger"
                          style="display: inline-block"
                          pTooltip='This section is only displayed in the FedRAMP template'>
                        </span>
                      </p>

                      <p-table [value]="standartAndGuidances" [rows]="10" selectionMode="single"
                        [(selection)]="selectedStandartAndGuidance" [paginator]="true" [style]="{'margin-top':'10px'}"
                        sortField="standartAndGuidanceId" #otherDesignatedContactsTable>

                        <ng-template pTemplate="caption">
                          <div class="ui-helper-clearfix">
                            <button type="button" pButton icon="pi pi-plus"
                              (click)="showDialogToAddStandartAndGuidance()" class="risksponge-button"
                              style="float:right">
                            </button>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                          <tr>
                            <th *ngFor="let col of standartAndGuidanceCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                              {{ col.header }}
                              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            </th>
                            <th [ngStyle]="{width:'7em'}"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                          <tr>
                            <td>{{ item.identificationNumber }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ item.date | date : 'shortDate' }}</td>
                            <td>{{ item.link }}</td>
                            <td>
                              <button type="button" pButton class="risksponge-button"
                                (click)="editStandartAndGuidance(item)" icon="pi pi-pencil">
                              </button>

                              <button type="button" pButton class="risksponge-button"
                                (click)="deleteStandartAndGuidance(item)" icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>
                    </ng-container>


                    <div style="margin-top: 10px" class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>

                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Sub-systems & Services</mat-panel-title>
                    <mat-panel-description>
                      Details on sub-systems and services
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Sub-systems & Services -->
                  <div formGroupName="3" [stepControl]="{invalid: false}">
                    <p style="font-size:14px;margin: 0px 0 5px 0;">
                      <span class="tooltip-trigger"
                        style="display: inline-block;margin-left: 10px; width: 20px; height: 20px;"
                        pTooltip='This section is only displayed in the Standard w/ Recs template'>
                      </span>
                    </p>

                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width" style="margin-top: 8px;">
                          <mat-checkbox type="text" formControlName="locationSectionVisible">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                      <div style="flex:1 1 auto">
                        <mat-form-field class="input-section" style="margin-left: 20px;">
                          <mat-label>SSP Section Name</mat-label>
                          <input matInput required formControlName="locationSectionTitle">
                        </mat-form-field>
                      </div>
                    </div>

                    <p-table [value]="systemLocations" [rows]="10" selectionMode="single"
                      [(selection)]="selectedSystemLocation" [paginator]="true" [style]="{'margin-top':'10px'}"
                      sortField="systemLocationId" #systemLocationsTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix" style="display: flex; flex-direction: row; justify-content: flex-end">
                          <div>
                            <mat-form-field style="margin-right: 10px;">
                              <mat-label>Project</mat-label>
                              <mat-select formControlName="servicesProjectId">
                                <mat-option *ngFor="let project of projects" [value]="project.projectId">{{ project.name
                                  }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="margin-right: 10px;">
                            <button type="button" pButton icon="pi pi-paperclip" (click)="populateServices()"
                              pTooltip="Populates 3rd party services from the selected project's controls into the Sub-Systems & Services table."
                              tooltipPosition="top" class="risksponge-button" style="float:right">
                            </button>
                          </div>
                          <div>
                            <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddSystemLocation()"
                              class="risksponge-button" style="float:right">
                            </button>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of systemLocationsCols" [pSortableColumn]="col.field"
                            [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.subSystemName }}</td>
                          <td>{{ item.systemType }}</td>
                          <td>{{ item.responsibility }}</td>
                          <td>{{ item.location }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button" (click)="onSystemLocationEdit(item)"
                              icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                              (click)="onSystemLocationDelete(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>
                    <p-dialog header="System Location" [(visible)]="displaySystemLocationDialog"
                      showEffect="fade" [width]="300" [draggable]="false" [resizable]="false" class="dialog">

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Sub-System/Service Name</mat-label>
                        <input matInput name="role" required formControlName="subSystemName">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Type</mat-label>
                        <input matInput name="role" required formControlName="systemType">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Responsibility</mat-label>
                        <input matInput name="role" required formControlName="responsibility">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field class="input-section" style="width: 92%; margin-left: 15px; margin-right: 15px;">
                        <mat-label>Location</mat-label>
                        <input matInput name="role" required formControlName="location">
                        <mat-error>This field is required</mat-error>
                      </mat-form-field>


                        <alert></alert>
                        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button"
                          >
                          <button mat-raised-button (click)="saveSystemLocation()">
                            Save
                          </button>


                          <button mat-raised-button class="cancel-button" (click)="closeSystemLocationDialog()">
                            Cancel
                          </button>
                        </div>

                    </p-dialog>
                    <div style="margin-top: 10px" class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>

                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> IT & OT Devices</mat-panel-title>
                    <mat-panel-description>
                      Manage IT and OT devices
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- IT & OT Devices -->
                  <div formGroupName="3" [stepControl]="{invalid: false}">
                    <p style="font-size:16px;margin: 20px 0 5px 0;"><strong>OT Devices</strong></p>
                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width">
                          <mat-checkbox type="text" formControlName="devicesSectionVisible" style="margin-top: 3px;">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>

                    <p-table [value]="devices" [rows]="10" selectionMode="single" [(selection)]="selectedDevice"
                      [paginator]="true" [style]="{'margin-top':'10px', 'white-space':'nowrap'}" sortField="deviceId"
                      #devicesTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix" style="display: flex; flex-direction: row; justify-content: flex-end">
                          <div>
                            <label class="risksponge-button" for="devicesButton"
                                   style="margin-right: 15px; line-height: 32px; padding: 2.5px 1em 2.5px 1.1em;color: orange;">
                              <i class="pi pi-paperclip" style="font-size: 15px; margin-right: -10px;"></i>
                              <input id="devicesButton" type="file" (change)="populateDevices($event)"
                                     name="devicesButton" style="display: none;" />
                            </label>
                            <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddDevice()"
                                    class="risksponge-button" style="float:right">
                            </button>
                          </div>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of devicesCols" [pSortableColumn]="col.field"
                            [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <td>Monitoring</td>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td *ngIf="itProfile.isDeviceNameVisible !== false">{{ item.deviceName }}</td>
                          <td *ngIf="itProfile.isTypeVisible !== false">{{ item.type }}</td>
                          <td *ngIf="itProfile.isManufacturerVisible !== false">{{ item.manufacturer }}</td>
                          <td *ngIf="itProfile.isModelVisible !== false">{{ item.model }}</td>
                          <td *ngIf="itProfile.isSerialNumberVisible !== false">{{ item.serialNumber }}</td>
                          <td *ngIf="itProfile.isIPVisible !== false">{{ item.ip }}</td>
                          <td *ngIf="itProfile.isMACVisible !== false">{{ item.mac }}</td>
                          <td *ngIf="itProfile.isPUIDVisible !== false">{{ item.puid }}</td>
                          <td *ngIf="itProfile.isOwnerVisible !== false">{{ item.owner }}</td>
                          <td *ngIf="itProfile.isLocationVisible !== false">{{ item.location }}</td>
                          <td>
                            @for (result of item.findings; track result.id) {
                              <div class="cursor-pointer underline" (click)="openFindings(result)">{{result.date | date:'shortDate' }}</div>
                            }
                          </td>
                          <td>
                            @if (diagrams.length) {
                              <button type="button" pButton class="risksponge-button" (click)="setDevicePosition(item)"
                                      icon="pi pi-map-marker">
                              </button>
                            }

                            <button type="button" pButton class="risksponge-button" (click)="onDeviceEdit(item)"
                                    icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button" (click)="onDeviceDelete(item)"
                              icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>


                    <p-dialog header="Device" [(visible)]="displayDeviceDialog"  showEffect="fade"
                      style="z-index: 100;" [draggable]="false" [resizable]="false" [width]="500" class="dialog">
                      <div style="width: 1000px;">
                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isDeviceNameVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameDeviceName || 'Device Name'}}</mat-label>
                          <input matInput name="role" required formControlName="deviceName">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isTypeVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameType || 'Type'}}</mat-label>
                          <input matInput name="role" required formControlName="type">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isManufacturerVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameManufacturer || 'Manufacturer'}}</mat-label>
                          <input matInput name="role" required formControlName="manufacturer">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isModelVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameModel || 'Model'}}</mat-label>
                          <input matInput name="role" required formControlName="model">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isSerialNumberVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameSerialNumber || 'Serial Number'}}</mat-label>
                          <input matInput name="role" required formControlName="serialNumber">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isIPVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameIP || 'IP'}}</mat-label>
                          <input matInput name="role" required formControlName="ip">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isMACVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameMAC || 'MAC'}}</mat-label>
                          <input matInput name="role" required formControlName="mac">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isPUIDVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNamePUID || 'PUID'}}</mat-label>
                          <input matInput name="role" required formControlName="puid">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isOwnerVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameOwner || 'Owner'}}</mat-label>
                          <input matInput name="role" required formControlName="owner">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="input-section"
                          style="width: 96%; margin-left: 15px; margin-right: 15px;" *ngIf="itProfile.isLocationVisible !== false">
                          <mat-label>{{itProfile.deviceFieldNameLocation || 'Location'}}</mat-label>
                          <input matInput name="role" required formControlName="deviceLocation">
                          <mat-error>This field is required</mat-error>
                        </mat-form-field>

                        <div *ngIf="!isMaster">
                          <div class="splitter">Control Items</div>
                          <p-table [value]="projectControlItems">
                            <ng-template pTemplate="header">
                              <tr>
                                <th>Project Name</th>
                                <th>Control ID</th>
                                <th>Framework</th>
                                <th>Category</th>
                                <th>Control Name</th>
                                <th style="width: 3em;"></th>
                              </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-item>
                              <tr>
                                <td>{{ item.projectName }}</td>
                                <td>{{ item.controlItem.complianceAreaControlId }}</td>
                                <td>{{ item.controlItem.complianceAreaName }}</td>
                                <td>{{ item.controlItem.category }}</td>
                                <td>{{ item.controlItem.name }}</td>
                                <td>
                                  <button type="button" pButton class="risksponge-button"
                                    (click)="removeProjectControlItem(item)" icon="pi pi-trash">
                                  </button>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                          <div>
                            <button type="button" pButton class="risksponge-button" (click)="addProjectControlItem()"
                              icon="pi pi-plus">
                            </button>
                          </div>
                        </div>
                      </div>
                      <alert></alert>
                      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin-bottom: 15px;" class="save-button"
                        >
                        <button mat-raised-button (click)="saveDevice()">
                          Save
                        </button>


                        <button mat-raised-button class="cancel-button" (click)="closeDeviceDialog()">
                          Cancel
                        </button>
                      </div>
                    </p-dialog>

                    <div style="margin-top: 10px" class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>

                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="FedRAMP">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Identifiers & Categorization </mat-panel-title>
                    <mat-panel-description>
                      Manage identifiers and categorization for FedRAMP.
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Identifiers & Categorization -->
                  <div formGroupName="14" [stepControl]="{invalid: false}"
                    *ngIf="formArray.get([11]).controls.isFedRamp.value">
                    <ng-template matStepLabel>
                      <div>FedRAMP</div>
                    </ng-template>
                    <p style="font-size:16px;">
                      <strong>Information System Name</strong><span class="tooltip-trigger"
                        style="display: inline-block;margin-left: 10px; width: 20px; height: 20px;"
                        pTooltip='Editable on Intro & Summary section'>
                      </span>
                    </p>
                    <div style="display: flex; gap: 40px;">
                      <mat-form-field class="input-section" style="flex: 1 1 20%;">
                        <mat-label>Unique Identifier</mat-label>
                        <input matInput type="text" readonly
                          [value]="formArray.get([1]).controls.fedRampApplicationNumber.value" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="flex: 1 1 20%; margin-right: 5px;">
                        <mat-label>System Name</mat-label>
                        <input matInput type="text" readonly [value]="formArray.get([1]).controls.systemName.value" />
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>
                      <mat-form-field class="input-section" style="flex: 1 1 20%;">
                        <mat-label>System Name Abbreviation</mat-label>
                        <input matInput type="text" readonly
                          [value]="formArray.get([1]).controls.systemNameAbbreviation.value" />
                        <mat-error>The input is invalid.</mat-error>
                      </mat-form-field>
                    </div>
                    <p style="font-size:16px;"><strong style="padding-right: 10px;">Information System
                        Categorization</strong></p>
                    <mat-form-field class="input-section" style="width: 400px;">
                      <mat-label>System Sensitivity Level</mat-label>
                      <mat-select type="text" formControlName="systemSensivityLevel">
                        <mat-option [value]="0">Low (L)</mat-option>
                        <mat-option [value]="1">Moderate (M)</mat-option>
                        <mat-option [value]="2">High (H)</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <p style="font-size:16px;">
                      <strong style="padding-right: 10px;">
                        Security Objectives Categorization (FIPS
                        199)
                      </strong>
                    </p>
                    <div style="display: flex; gap: 20px;">
                      <mat-form-field class="input-section" style="width: 300px;">
                        <mat-label>Confidentiality</mat-label>
                        <mat-select type="text" formControlName="confidentiality">
                          <mat-option [value]="0">Low (L)</mat-option>
                          <mat-option [value]="1">Moderate (M)</mat-option>
                          <mat-option [value]="2">High (H)</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 300px;">
                        <mat-label>Integrity</mat-label>
                        <mat-select type="text" formControlName="integrity">
                          <mat-option [value]="0">Low (L)</mat-option>
                          <mat-option [value]="1">Moderate (M)</mat-option>
                          <mat-option [value]="2">High (H)</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="display: flex; gap: 20px;">
                      <mat-form-field class="input-section" style="width: 300px;">
                        <mat-label>Availability</mat-label>
                        <mat-select type="text" formControlName="availability">
                          <mat-option [value]="0">Low (L)</mat-option>
                          <mat-option [value]="1">Moderate (M)</mat-option>
                          <mat-option [value]="2">High (H)</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 300px;">
                        <mat-label>Abbreviation Categorization</mat-label>
                        <mat-select type="text" formControlName="abbreviationCategorization">
                          <mat-option [value]="0">Low (L)</mat-option>
                          <mat-option [value]="1">Moderate (M)</mat-option>
                          <mat-option [value]="2">High (H)</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <p style="font-size:16px;"><strong style="padding-right: 10px;">System Status</strong></p>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSystemStatusOperational">
                        Operational - The system is operating and in production.
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSystemStatusUnderDevelopment">
                        Under Development - The system is being designed, developed, or implemented
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSystemStatusMajorModification">
                        Major Modification - The system is undergoing a major change, development, or transition.
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSystemStatusOther">
                        Other
                      </mat-checkbox>
                    </div>
                    <mat-form-field class="example-full-width">
                      <mat-label>System Status Other Explanation</mat-label>
                      <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="systemStatusOtherExplanation">
                </textarea>
                    </mat-form-field>
                    <p style="font-size:16px;">
                      <strong style="padding-right: 10px;">
                        Service Layers Represented in this
                        SSP
                      </strong>
                    </p>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSoftwareLayer">
                        Major Application - Software as a Service (SaaS)
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isPlatformLayer">
                        Major Application - Platform as a Service (PaaS)
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isInfrastructureLayer">
                        General Support System - Infrastructure as a Service (IaaS)
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isOtherLayer">
                        Other Layer
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-form-field class="textarea-section" style="width: 400px; margin-top: 10px;">
                        <mat-label>Other Layer</mat-label>
                        <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="otherLayer">
                </textarea>
                      </mat-form-field>
                    </div>
                    <p style="font-size:16px;"><strong style="padding-right: 10px;">Cloud Deployment Model</strong></p>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isPublicCloud">
                        Public - Cloud services and infrastructure supporting multiple organizations and agency clients
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isPrivateCloud">
                        public - Cloud services and infrastructure dedicated to a specific organization/agency and no
                        other
                        clients
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isGovernmentCloud">
                        Government Only - Community Cloud services and infrastructure shared by several
                        organizations/agencies
                        with same policy and compliance considerations
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isHybridCloud">
                        Hybrid - Explain: (e.g., cloud services and infrastructure that provides public cloud for
                        secured
                        applications and data where required and public cloud for other applications and data)
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-form-field class="textarea-section" style="width: 400px; margin-top: 10px;">
                        <mat-label>Hybrid Cloud Details</mat-label>
                        <textarea matInput type="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" formControlName="hybridCloud">
           </textarea>
                      </mat-form-field>
                    </div>

                    <p style="font-size:16px;"><strong style="padding-right: 10px;">OSCAL</strong></p>
                    <div style="display: flex; gap: 20px;">
                      <mat-form-field class="input-section" style="width: 200px;">
                        <mat-label>Identity Assurance Level</mat-label>
                        <mat-select type="text" formControlName="identityAssuranceLevel">
                          <mat-option [value]="1">Low</mat-option>
                          <mat-option [value]="2">Moderate</mat-option>
                          <mat-option [value]="3">High</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 200px;">
                        <mat-label>Authenticator Assurance Level</mat-label>
                        <mat-select type="text" formControlName="authenticatorAssuranceLevel">
                          <mat-option [value]="1">Low</mat-option>
                          <mat-option [value]="2">Moderate</mat-option>
                          <mat-option [value]="3">High</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 200px;">
                        <mat-label>Federation Assurance Level</mat-label>
                        <mat-select type="text" formControlName="federationAssuranceLevel">
                          <mat-option [value]="1">Low</mat-option>
                          <mat-option [value]="2">Moderate</mat-option>
                          <mat-option [value]="3">High</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <p style="font-size:16px;"><strong style="padding-right: 10px;">Privacy Threshold Analysis</strong>
                    </p>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isaSharesPii">
                        Does the Interconnection Security Agreement (ISA) collect, maintain, or
                        share PII in any identifiable form?
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isaSharesPiiPublic">
                        Does the ISA collect, maintain, or share PII information from or about the
                        public?
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="piaPerformedForIsa">
                        Has a Privacy Impact Assessment ever been performed for the ISA?
                      </mat-checkbox>
                    </div>
                    <div class="example-full-width">
                      <mat-checkbox type="text" formControlName="isSorn">
                        Is there a Privacy Act System of Records Notice (SORN) for this ISA
                        system?
                      </mat-checkbox>
                    </div>
                    <mat-form-field class="input-section" style="width: 400px; margin-top: 10px;"
                      *ngIf="formArray.get([14]).controls.isSorn.value">
                      <mat-label>SORN</mat-label>
                      <input matInput type="text" formControlName="sorn" />
                    </mat-form-field>

                    <div class="save-button">
                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>

                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Classifications</mat-panel-title>
                    <mat-panel-description>
                      Classifications as required by FedRAMP
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- FedRAMP 5 -->
                  <div formGroupName="26" [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      FedRAMP 5
                    </ng-template>
                    <div style="display: grid;">
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>CSO Name</mat-label>
                        <input matInput type="text" formControlName="csoName" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>CSO Abbreviation</mat-label>
                        <input matInput type="text" formControlName="csoAbbreviation" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>CSO Categorization</mat-label>
                        <input matInput type="text" formControlName="csoCategorization" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>CSP Name</mat-label>
                        <input matInput type="text" formControlName="cspName" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>CSP Abbreviation</mat-label>
                        <input matInput type="text" formControlName="cspAbbreviation" />
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width: 400px;">
                        <mat-label>FedRAMP Package ID</mat-label>
                        <input matInput type="text" formControlName="fedRampPackageId" />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Service Model</mat-label>
                        <mat-select type="text" formControlName="serviceModel">
                          <mat-option value=""></mat-option>
                          <mat-option value="IaaS">IaaS</mat-option>
                          <mat-option value="PaaS">PaaS</mat-option>
                          <mat-option value="SaaS">SaaS</mat-option>
                          <mat-option value="IaaS/PaaS">IaaS/PaaS</mat-option>
                          <mat-option value="IaaS/PaaS/SaaS">IaaS/PaaS/SaaS</mat-option>
                          <mat-option value="IaaS/SaaS">IaaS/SaaS</mat-option>
                          <mat-option value="PaaS/SaaS">PaaS/SaaS</mat-option>
                          <mat-option value="LI-SaaS">LI-SaaS</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Digital Identity Level (DIL) Determination (SSP Appendix E)</mat-label>
                        <mat-select type="text" formControlName="digitalIdentityLevel">
                          <mat-option value=""></mat-option>
                          <mat-option value="IAL3/FAL3/AAL3">IAL3/FAL3/AAL3</mat-option>
                          <mat-option value="IAL2/FAL2/AAL2">IAL2/FAL2/AAL2</mat-option>
                          <mat-option value="IAL1/FAL1/AAL1">IAL1/FAL1/AAL1</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>FIPS PUB 199 Level (SSP Appendix K)</mat-label>
                        <mat-select type="text" formControlName="fipsLevel">
                          <mat-option value=""></mat-option>
                          <mat-option value="High">High</mat-option>
                          <mat-option value="Moderate">Moderate</mat-option>
                          <mat-option value="Low">Low</mat-option>
                          <mat-option value="LI-SaaS">LI-SaaS</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div style="width: 200px;">
                        <label class="block font-bold mb-2">Fully Operational as of</label>
                        <input pInputText name="date" class="w-full p-inputtext" formControlName="operationalDate"
                               [matDatepicker]="pickerOperational" required>
                        <mat-datepicker-toggle class="date-picker" matSuffix [for]="pickerOperational"></mat-datepicker-toggle>
                        <mat-datepicker #pickerOperational></mat-datepicker>
                      </div>
                      <mat-form-field>
                        <mat-label>Deployment Model</mat-label>
                        <mat-select type="text" formControlName="deploymentModel">
                          <mat-option value=""></mat-option>
                          <mat-option value="Public Cloud">Public Cloud</mat-option>
                          <mat-option value="Government-Only Cloud">Government-Only Cloud</mat-option>
                          <mat-option value="Hybrid Cloud">Hybrid Cloud</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Authorization Path</mat-label>
                        <mat-select type="text" formControlName="authorizationPath">
                          <mat-option value=""></mat-option>
                          <mat-option value="Joint Authorization Board Provisional Authorization">Joint Authorization Board Provisional Authorization</mat-option>
                          <mat-option value="Agency Authorization">Agency Authorization</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-checkbox formControlName="separationOfDutiesVisible">Separation of Duties
                        visible</mat-checkbox>
                    </div>
                    <label class="block font-bold mb-2">Information Types</label>
                    <p-table [value]="informationTypes" [rows]="10" selectionMode="single"
                      [(selection)]="selectedInformationType" [paginator]="true" [style]="{'margin-top':'10px'}"
                      sortField="informationTypeId" #otherDesignatedContactsTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddInformationType()"
                            class="risksponge-button" style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of informationTypeCols" [pSortableColumn]="col.field"
                            [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.name }}</td>
                          <td>{{ lowMediumHigh[item.recommendedConfidentialityLevel] }}</td>
                          <td>{{ lowMediumHigh[item.recommendedIntegrityLevel] }}</td>
                          <td>{{ lowMediumHigh[item.recommendedAvailabilityLevel] }}</td>
                          <td>{{ lowMediumHigh[item.selectedConfidentialityLevel] }}</td>
                          <td>{{ lowMediumHigh[item.selectedIntegrityLevel] }}</td>
                          <td>{{ lowMediumHigh[item.selectedAvailabilityLevel] }}</td>
                          <td>{{ item.statement }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button" (click)="editInformationType(item)"
                              icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                              (click)="deleteInformationType(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>

                    <label class="block font-bold mb-2">Authorized Services</label>
                    <p-table [value]="authorizedServices" [rows]="10" selectionMode="single"
                             [(selection)]="selectedAuthorizedService" [paginator]="true"
                             [style]="{'margin-top':'10px'}" sortField="authorizedServiceId"
                             #otherDesignatedContactsTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus"
                                  (click)="showDialogToAddAuthorizedService()" class="risksponge-button"
                                  style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of authorizedServiceCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.name }}</td>
                          <td>{{ item.service }}</td>
                          <td>{{ item.authorizationType }}</td>
                          <td>{{ item.fedRampPackageId }}</td>
                          <td>{{ item.nature }}</td>
                          <td>{{ item.impactLevel }}</td>
                          <td>{{ item.dataTypes }}</td>
                          <td>{{ item.users }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button"
                                    (click)="editAuthorizedService(item)" icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                                    (click)="deleteAuthorizedService(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>

                    <label class="block font-bold mb-2">External Systems</label>
                    <p-table [value]="externalSystems" [rows]="10" selectionMode="single"
                             [(selection)]="selectedExternalSystem" [paginator]="true"
                             [style]="{'margin-top':'10px'}" sortField="externalSystemId"
                             #otherDesignatedContactsTable>

                      <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                          <button type="button" pButton icon="pi pi-plus"
                                  (click)="showDialogToAddExternalSystem()" class="risksponge-button"
                                  style="float:right">
                          </button>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="header">
                        <tr>
                          <th *ngFor="let col of externalSystemCols" [pSortableColumn]="col.field"
                              [ngStyle]="{ width: col.width || 'auto' }">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                          </th>
                          <th [ngStyle]="{width:'7em'}"></th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                        <tr>
                          <td>{{ item.number }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.connectionDetails }}</td>
                          <td>{{ item.nature }}</td>
                          <td>{{ item.isSupported ? 'Yes' : 'No' }}</td>
                          <td>{{ item.dataTypes }}</td>
                          <td>{{ item.dataCategorization }}</td>
                          <td>{{ item.users }}</td>
                          <td>{{ item.impactLevel }}</td>
                          <td>{{ item.otherPrograms }}</td>
                          <td>{{ item.description }}</td>
                          <td>{{ item.hostingEnvironment }}</td>
                          <td>{{ item.riskImpactMitigation }}</td>
                          <td>
                            <button type="button" pButton class="risksponge-button"
                                    (click)="editExternalSystem(item)" icon="pi pi-pencil">
                            </button>

                            <button type="button" pButton class="risksponge-button"
                                    (click)="deleteExternalSystem(item)" icon="pi pi-trash">
                            </button>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>

                    <div style="margin-top: 10px" class="save-button">
                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>

                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>Appendix Attachments</mat-panel-title>
                    <mat-panel-description>
                      Manage attachments for FedRAMP compliance
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Attachments SSP Document -->
                  <div [stepControl]="{invalid: false}">
                    <ng-template matStepLabel>
                      SSP Documents
                    </ng-template>
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <p style="font-size:16px;">
                              <strong>
                                Appendix Name
                              </strong>
                            </p>
                          </th>
                          <th>
                            <p style="font-size:16px;">
                              <strong>
                                Filename
                              </strong>
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix B Related Acronyms
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!relatedAcronyms">
                              <label class="mat-button mat-raised-button" for="addrelatedAcronymsFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addrelatedAcronymsFile" type="file" (change)="addItProfileDocuments($event, 'relatedAcronyms')"
                                       name="addrelatedAcronymsFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="relatedAcronyms">
                        <span (click)="downloadFile(relatedAcronyms)" class="btn btn-link">
                          {{ relatedAcronyms }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updaterelatedAcronymsFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updaterelatedAcronymsFile" type="file" (change)="addItProfileDocuments($event, 'relatedAcronyms')"
                                       name="updaterelatedAcronymsFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Related Acronyms'"
                                     [popoverMessage]="'You are going to remove Related Acronyms. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="relatedAcronyms=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Related Acronyms
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix C Information Security Policies and Procedures
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!policiesAndProcedures">
                              <label class="mat-button mat-raised-button" for="addpoliciesAndProceduresFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addpoliciesAndProceduresFile" type="file" (change)="addItProfileDocuments($event, 'policiesAndProcedures')"
                                       name="addpoliciesAndProceduresFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="policiesAndProcedures">
                        <span (click)="downloadFile(policiesAndProcedures)" class="btn btn-link">
                          {{ policiesAndProcedures }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatepoliciesAndProceduresFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatepoliciesAndProceduresFile" type="file" (change)="addItProfileDocuments($event, 'policiesAndProcedures')"
                                       name="updatepoliciesAndProceduresFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Information Security Policies and Procedures'"
                                     [popoverMessage]="'You are going to remove Information Security Policies and Procedures. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="policiesAndProcedures=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Information Security Policies and Procedures
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr formGroupName="25">
                        <td>
                          <p style="font-size:16px; float: left;">
                            <strong>
                              Appendix D User Guide
                            </strong>
                          </p>
                          <div class="example-full-width" style="float: right; width: auto;">
                            <mat-checkbox type="text" formControlName="isUserGuideUrl">
                              Use URL
                            </mat-checkbox>
                          </div>
                        </td>
                        <td>
                          <div style="display:flex; gap:30px; width:70%" *ngIf="formArray.get([25]).controls.isUserGuideUrl.value">
                            <mat-form-field class="input-section">
                              <mat-label>User Guide URL</mat-label>
                              <input matInput type="text" formControlName="userGuideUrl" />
                            </mat-form-field>
                          </div>
                          <div style="margin-bottom: 10px" *ngIf="!formArray.get([25]).controls.isUserGuideUrl.value">
                            <div *ngIf="!userGuide">
                              <label class="mat-button mat-raised-button" for="adduserGuideFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="adduserGuideFile" type="file" (change)="addItProfileDocuments($event, 'userGuide')"
                                       name="adduserGuideFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="userGuide">
                        <span (click)="downloadFile(userGuide)" class="btn btn-link">
                          {{ userGuide }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updateuserGuideFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updateuserGuideFile" type="file" (change)="addItProfileDocuments($event, 'userGuide')"
                                       name="updateuserGuideFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove User Guide'"
                                     [popoverMessage]="'You are going to remove User Guide. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="userGuide=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove User Guide
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix F Rules of Behavior
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!rulesOfBehaviour">
                              <label class="mat-button mat-raised-button" for="addrulesOfBehaviourFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addrulesOfBehaviourFile" type="file" (change)="addItProfileDocuments($event, 'rulesOfBehaviour')"
                                       name="addrulesOfBehaviourFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="rulesOfBehaviour">
                        <span (click)="downloadFile(rulesOfBehaviour)" class="btn btn-link">
                          {{ rulesOfBehaviour }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updaterulesOfBehaviourFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updaterulesOfBehaviourFile" type="file" (change)="addItProfileDocuments($event, 'rulesOfBehaviour')"
                                       name="updaterulesOfBehaviourFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Rules Of Behaviour'"
                                     [popoverMessage]="'You are going to remove Rules Of Behaviour. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="rulesOfBehaviour=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Rules Of Behaviour
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix G Contingency Plan
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!contingencyPlan">
                              <label class="mat-button mat-raised-button" for="addcontingencyPlanFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addcontingencyPlanFile" type="file" (change)="addItProfileDocuments($event, 'contingencyPlan')"
                                       name="addcontingencyPlanFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="contingencyPlan">
                        <span (click)="downloadFile(contingencyPlan)" class="btn btn-link">
                          {{ contingencyPlan }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatecontingencyPlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatecontingencyPlanFile" type="file" (change)="addItProfileDocuments($event, 'contingencyPlan')"
                                       name="updatecontingencyPlanFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover [title]="'Contingency Plan'"
                                     [popoverMessage]="'You are going to Remove Contingency Plan. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="contingencyPlan=null">
                                <i class="pi pi-trash"></i>
                                Remove Contingency Plan
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix H Configuration Management Plan
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!configurationManagementPlan">
                              <label class="mat-button mat-raised-button" for="addconfigurationManagementPlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="addconfigurationManagementPlanFile" type="file"
                                       (change)="addItProfileDocuments($event, 'configurationManagementPlan')" name="addconfigurationManagementPlanFile"
                                       style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="configurationManagementPlan">
                        <span (click)="downloadFile(configurationManagementPlan)" class="btn btn-link">
                          {{ configurationManagementPlan }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updateconfigurationManagementPlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updateconfigurationManagementPlanFile" type="file"
                                       (change)="addItProfileDocuments($event, 'configurationManagementPlan')" name="updateconfigurationManagementPlanFile"
                                       style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Configuration Management Plan'"
                                     [popoverMessage]="'You are going to remove Configuration Management Plan. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="configurationManagementPlan=null">
                                <i class="pi pi-trash"></i>
                                Remove Configuration Management Plan
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix I Incident Response Plan
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!incidentResponsePlan">
                              <label class="mat-button mat-raised-button" for="addincidentResponsePlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="addincidentResponsePlanFile" type="file"
                                       (change)="addItProfileDocuments($event, 'incidentResponsePlan')" name="addincidentResponsePlanFile"
                                       style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="incidentResponsePlan">
                        <span (click)="downloadFile(incidentResponsePlan)" class="btn btn-link">
                          {{ incidentResponsePlan }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updateincidentResponsePlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updateincidentResponsePlanFile" type="file"
                                       (change)="addItProfileDocuments($event, 'incidentResponsePlan')" name="updateincidentResponsePlanFile"
                                       style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Attach Rules Of Behaviour'"
                                     [popoverMessage]="'You are going to remove Attach Rules Of Behaviour. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="incidentResponsePlan=null">
                                <i class="pi pi-trash"></i>
                                Remove Attach Incident Response Plan
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix J Control Implementation Summary (CIS) and Customer Responsibilities Matrix (CRM) Workbook
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!controlImplementationSummary">
                              <label class="mat-button mat-raised-button" for="addcontrolImplementationSummaryFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addcontrolImplementationSummaryFile" type="file" (change)="addItProfileDocuments($event, 'controlImplementationSummary')"
                                       name="addcontrolImplementationSummaryFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="controlImplementationSummary">
                        <span (click)="downloadFile(controlImplementationSummary)" class="btn btn-link">
                          {{ controlImplementationSummary }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatecontrolImplementationSummaryFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatecontrolImplementationSummaryFile" type="file" (change)="addItProfileDocuments($event, 'controlImplementationSummary')"
                                       name="updatecontrolImplementationSummaryFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Control Implementation Summary (CIS) and Customer Responsibilities Matrix (CRM) Workbook'"
                                     [popoverMessage]="'You are going to remove Control Implementation Summary (CIS) and Customer Responsibilities Matrix (CRM) Workbook. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="controlImplementationSummary=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Control Implementation Summary (CIS) and Customer Responsibilities Matrix (CRM) Workbook'
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix M Integrated Inventory Workbook (IIW)
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!integratedInventoryWorkbook">
                              <label class="mat-button mat-raised-button" for="addintegratedInventoryWorkbookFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addintegratedInventoryWorkbookFile" type="file" (change)="addItProfileDocuments($event, 'integratedInventoryWorkbook')"
                                       name="addintegratedInventoryWorkbookFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="integratedInventoryWorkbook">
                        <span (click)="downloadFile(integratedInventoryWorkbook)" class="btn btn-link">
                          {{ integratedInventoryWorkbook }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updateintegratedInventoryWorkbookFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updateintegratedInventoryWorkbookFile" type="file" (change)="addItProfileDocuments($event, 'integratedInventoryWorkbook')"
                                       name="updateintegratedInventoryWorkbookFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Integrated Inventory Workbook (IIW)'"
                                     [popoverMessage]="'You are going to remove Integrated Inventory Workbook (IIW). Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="integratedInventoryWorkbook=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Integrated Inventory Workbook (IIW)
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix N Continuous Monitoring Plan
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!continuousMonitoringPlan">
                              <label class="mat-button mat-raised-button" for="addcontinuousMonitoringPlanFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addcontinuousMonitoringPlanFile" type="file" (change)="addItProfileDocuments($event, 'continuousMonitoringPlan')"
                                       name="addcontinuousMonitoringPlanFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="continuousMonitoringPlan">
                        <span (click)="downloadFile(continuousMonitoringPlan)" class="btn btn-link">
                          {{ continuousMonitoringPlan }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatecontinuousMonitoringPlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatecontinuousMonitoringPlanFile" type="file" (change)="addItProfileDocuments($event, 'continuousMonitoringPlan')"
                                       name="updatecontinuousMonitoringPlanFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Continuous Monitoring Plan'"
                                     [popoverMessage]="'You are going to remove Continuous Monitoring Plan. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="continuousMonitoringPlan=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Continuous Monitoring Plan
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix P Supply Chain Risk Management Plan
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!supplyChainRiskManagementPlan">
                              <label class="mat-button mat-raised-button" for="addsupplyChainRiskManagementPlanFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addsupplyChainRiskManagementPlanFile" type="file" (change)="addItProfileDocuments($event, 'supplyChainRiskManagementPlan')"
                                       name="addsupplyChainRiskManagementPlanFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="supplyChainRiskManagementPlan">
                        <span (click)="downloadFile(supplyChainRiskManagementPlan)" class="btn btn-link">
                          {{ supplyChainRiskManagementPlan }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatesupplyChainRiskManagementPlanFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatesupplyChainRiskManagementPlanFile" type="file" (change)="addItProfileDocuments($event, 'supplyChainRiskManagementPlan')"
                                       name="updatesupplyChainRiskManagementPlanFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Supply Chain Risk Management Plan'"
                                     [popoverMessage]="'You are going to remove Supply Chain Risk Management Plan. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="supplyChainRiskManagementPlan=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Supply Chain Risk Management Plan
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Appendix Q Cryptographic Modules Table
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!cryptographicModulesTable">
                              <label class="mat-button mat-raised-button" for="addcryptographicModulesTableFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addcryptographicModulesTableFile" type="file" (change)="addItProfileDocuments($event, 'cryptographicModulesTable')"
                                       name="addcryptographicModulesTableFile" style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="cryptographicModulesTable">
                        <span (click)="downloadFile(cryptographicModulesTable)" class="btn btn-link">
                          {{ cryptographicModulesTable }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updatecryptographicModulesTableFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updatecryptographicModulesTableFile" type="file" (change)="addItProfileDocuments($event, 'cryptographicModulesTable')"
                                       name="updatecryptographicModulesTableFile" style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Cryptographic Modules Table'"
                                     [popoverMessage]="'You are going to remove Cryptographic Modules Table. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="cryptographicModulesTable=null">
                                <i class="pi pi-trash" style="margin-right: 5px;"></i>
                                Remove Cryptographic Modules Table
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="font-size:16px;">
                            <strong>
                              Separation of Duties Matrix
                            </strong>
                          </p>
                        </td>
                        <td>
                          <div style="margin-bottom: 10px">
                            <div *ngIf="!seprationOfDutiesMatrix">
                              <label class="mat-button mat-raised-button" for="addseprationOfDutiesMatrixFile">
                                <i class="pi pi-paperclip"></i>
                                <input id="addseprationOfDutiesMatrixFile" type="file"
                                       (change)="addItProfileDocuments($event, 'seprationOfDutiesMatrix')" name="addseprationOfDutiesMatrixFile"
                                       style="display: none;" />
                              </label>
                            </div>
                            <div *ngIf="seprationOfDutiesMatrix">
                        <span (click)="downloadFile(seprationOfDutiesMatrix)" class="btn btn-link">
                          {{ seprationOfDutiesMatrix }}
                        </span>
                              <label class="mat-button mat-raised-button" for="updateseprationOfDutiesMatrixFile">
                                <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                                <input id="updateseprationOfDutiesMatrixFile" type="file"
                                       (change)="addItProfileDocuments($event, 'seprationOfDutiesMatrix')" name="updateseprationOfDutiesMatrixFile"
                                       style="display: none;" />
                              </label>
                              <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                     [title]="'Remove Separation of Duties Matrix'"
                                     [popoverMessage]="'You are going to remove Separation of Duties Matrix. Are you sure?'"
                                     [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                     (confirm)="seprationOfDutiesMatrix=null">
                                <i class="pi pi-trash"></i>
                                Remove Separation of Duties Matrix
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="save-button">

                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Separation of Duties Matrix Table</mat-panel-title>
                    <mat-panel-description>
                      Future addition for separation of duties matrix table.
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <p-table [value]="separationOfDuties"
                           [style]="{'margin-top':'10px'}"
                  >

                    <ng-template pTemplate="caption">
                      <div class="ui-helper-clearfix">
                        <button type="button"
                                pButton
                                icon="pi pi-plus"
                                (click)="showDialogToAddSeparationOfDutyRole()"
                                label="Add Role"
                                class="risksponge-button"
                                style="float:right">
                        </button>
                      </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                      <tr>
                        <th></th>
                        <th *ngFor="let role of separationOfDutyRoles">
                          {{ role.name }}
                          <button type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="editSeparationOfDutyRole(role)"
                                  icon="pi pi-pencil">
                          </button>

                          <button type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="deleteSeparationOfDutyRole(role)"
                                  icon="pi pi-trash">
                          </button>
                        </th>
                        <th [ngStyle]="{width:'7em'}"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                      <tr>
                        <td>{{ item.name }}</td>
                        <td *ngFor="let role of separationOfDutyRoles">
                          <mat-checkbox [(ngModel)]="item.selectedRoles[role.separationOfDutyRoleId]" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                        </td>
                        <td [ngStyle]="{width:'7em'}">
                          <button type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="editSeparationOfDuty(item)"
                                  icon="pi pi-pencil">
                          </button>

                          <button type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="deleteSeparationOfDuty(item)"
                                  icon="pi pi-trash">
                          </button>
                        </td>
                      </tr>
                    </ng-template>

                  </p-table>

                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showDialogToAddSeparationOfDuty()"
                          label="Add Duty"
                          class="risksponge-button">
                  </button>

                  <div class="save-button">

                    <button mat-raised-button (click)="onDone()">
                      Save
                    </button>
                  </div>

                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Digital Identity Worksheet Table (Coming)</mat-panel-title>
                    <mat-panel-description>
                      Future addition for digital identity worksheet table
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Digital Identity Worksheet Table Content here -->
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-tab>
          <mat-tab label="Custom">
            <div class="section" style="overflow: scroll; height: calc(100vh - 262px);">
              <mat-accordion formGroupName="12">
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                  *ngFor="let step of itProfile.quizData.steps; let i = index">
                  <mat-expansion-panel-header>
                    <mat-panel-title> {{ step.name }} </mat-panel-title>
                    <mat-panel-description>

                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- Custom -->
                  <div>

                    <div style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <div class="example-full-width" style="margin-top: 8px;">
                          <mat-checkbox type="text" [formControlName]="'customVisible' + i">
                            Visible in SSP
                          </mat-checkbox>
                        </div>
                      </div>
                      <div style="flex:0 0 2%"></div>
                      <div style="flex:1 1 auto">
                        <mat-form-field class="input-section" style="margin-left: 20px;">
                          <mat-label>SSP Section Name</mat-label>
                          <input matInput required [formControlName]="'customTitle' + i">
                        </mat-form-field>
                      </div>
                    </div>

                    <div *ngFor="let item of step.items;let q = index" class="item" style="margin-top: 10px">
                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:1 1 calc(100%)" class="question">
                          <ng-container *ngIf="item.type == 'question'">
                            <div style="display: flex; flex-direction: row; font-weight: bold;font-size: 1.2em;margin-bottom:10px;">
                              {{ q + 1 }}) {{ item.name }}
                            </div>
                            <div style="margin-left: 10px;" *ngIf="!item.multiple">

                              <mat-radio-group [name]="'r' + i + '_' + q" [formControlName]="'r' + i + '_' + q">
                                <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                                  <div style="flex:0 0 auto">
                                    <mat-radio-button [value]="h">{{ 'ABCDEFGHIJKL'[h] }}. {{ a.name
                                      }}</mat-radio-button>
                                  </div>
                                </div>
                              </mat-radio-group>
                            </div>
                            <div style="margin-left: 10px;" *ngIf="item.multiple">
                              <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                                <div style="flex:0 0 50px">
                                  <mat-checkbox [name]="'r' + i + '_' + q + '_' + h"
                                    [formControlName]="'r' + i + '_' + q + '_' + h">
                                    {{ 'ABCDEFGHIJKL'[h] }}
                                    . {{ a.name }}
                                  </mat-checkbox>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>


                    <div class="save-button">
                      <button mat-raised-button (click)="onDone()">
                        Save
                      </button>
                    </div>


                  </div>
                </mat-expansion-panel>

              </mat-accordion>
            </div>
          </mat-tab>
        </mat-tab-group>



      </div>
    </div>
    <ng-container formArrayName="formArray">
      <p-dialog header="Law and Regulation" [(visible)]="displayLawAndRegulationDialog"
        showEffect="fade" [width]="300" formGroupName="22" class="dialog">

        <mat-form-field class="dialog-control-width">
          <mat-label>Identification Number</mat-label>
          <input matInput name="role" required formControlName="identificationNumber">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Title</mat-label>
          <input matInput name="role" required formControlName="title">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Date</mat-label>
          <input matInput name="role" required [matDatepicker]="lawAndRegulationPicker" formControlName="date">
          <mat-error>This field is required</mat-error>
          <mat-datepicker-toggle matSuffix [for]="lawAndRegulationPicker"></mat-datepicker-toggle>
          <mat-datepicker #lawAndRegulationPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Link</mat-label>
          <input matInput name="role" required formControlName="link">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button (click)="saveLawAndRegulation()">
              Save
            </button>


            <button mat-raised-button (click)="closeLawAndRegulationDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>
      <p-dialog header="Standard and Guidance" [(visible)]="displayStandartAndGuidanceDialog"
        showEffect="fade" [width]="300" formGroupName="23" class="dialog">

        <mat-form-field class="dialog-control-width">
          <mat-label>Identification Number</mat-label>
          <input matInput name="role" required formControlName="identificationNumber">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Title</mat-label>
          <input matInput name="role" required formControlName="title">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Date</mat-label>
          <input matInput name="role" required [matDatepicker]="standartAndGuidancePicker" formControlName="date">
          <mat-error>This field is required</mat-error>
          <mat-datepicker-toggle matSuffix [for]="standartAndGuidancePicker"></mat-datepicker-toggle>
          <mat-datepicker #standartAndGuidancePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Link</mat-label>
          <input matInput name="role" required formControlName="link">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button (click)="saveStandartAndGuidance()">
              Save
            </button>


            <button mat-raised-button (click)="closeStandartAndGuidanceDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>
      <p-dialog header="Separation of Duty"
                [(visible)]="displaySeparationOfDutyDialog"

                showEffect="fade"
                [width]="300"
                formGroupName="28">

        <mat-form-field class="dialog-control-width">
          <mat-label>Name</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="name">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button
                    (click)="saveSeparationOfDuty()">
              Save
            </button>


            <button mat-raised-button
                    (click)="closeSeparationOfDutyDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>

      <p-dialog header="Role"
                [(visible)]="displaySeparationOfDutyRoleDialog"

                showEffect="fade"
                [width]="300"
                formGroupName="29">

        <mat-form-field class="dialog-control-width">
          <mat-label>Name</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="name">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button
                    (click)="saveSeparationOfDutyRole()">
              Save
            </button>


            <button mat-raised-button
                    (click)="closeSeparationOfDutyRoleDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>

      <p-dialog header="Authorized Service"
                [(visible)]="displayAuthorizedServiceDialog"

                showEffect="fade"
                [width]="300"
                formGroupName="30">

        <mat-form-field class="dialog-control-width">
          <mat-label>CSP/CSO Name (Name on FedRAMP Marketplace)</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="name">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>CSO Service (Names of services and features - services from a single CSO can be all listed in one cell)</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="service">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Authorization Type (JAB or Agency)</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="authorizationType">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>FedRAMP Package ID #</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="fedRampPackageId">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Nature of Agreement</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="nature">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Impact Level</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="impactLevel">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Data Types</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="dataTypes">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Authorized Users/Authentication</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="users">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button
                    (click)="saveAuthorizedService()">
              Save
            </button>


            <button mat-raised-button
                    (click)="closeAuthorizedServiceDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>

      <p-dialog header="External System"
                [(visible)]="displayExternalSystemDialog"

                showEffect="fade"
                [width]="300"
                formGroupName="31">

        <mat-form-field class="dialog-control-width">
          <mat-label>#</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="number">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>System/ Service/ API/CLI Name (Non-FedRAMP Cloud Services)</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="name">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Connection Details</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="connectionDetails">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Nature of Agreement</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="nature">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <div class="example-full-width" style="width: 295px;">
          <mat-checkbox type="text" formControlName="isSupported">
            Still Supported?
          </mat-checkbox>
        </div>

        <mat-form-field class="dialog-control-width">
          <mat-label>Data Types</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="dataTypes">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Data Categorization</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="dataCategorization">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Authorized Users/ Authentication</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="users">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Other Compliance Programs</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="otherPrograms">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Description</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="description">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Hosting Environment</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="hostingEnvironment">
          <mat-error>This field is required</mat-error>
        </mat-form-field>

        <mat-form-field class="dialog-control-width">
          <mat-label>Risk/Impact/ Mitigation</mat-label>
          <input matInput
                 name="role"
                 required
                 formControlName="riskImpactMitigation">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


          <alert></alert>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
            <button mat-raised-button
                    (click)="saveExternalSystem()">
              Save
            </button>


            <button mat-raised-button
                    (click)="closeExternalSystemDialog()">
              Cancel
            </button>
          </div>

      </p-dialog>
    </ng-container>
  </form>
</div>
